'use strict';

import ListTracker from '../MetricsTracker/list/metrics';
import FooterTracker from '../MetricsTracker/footer/metrics';
import GoogleMapList from '../utils/maps/GoogleMapList';
import ListUtil from '../utils/pricetravel/list/utils';
import GlobalUtil from '../utils/pricetravel/shared/globalUtil';
import { matchFamilyRule, paxRateFamily, familyRequote } from '../utils/pricetravel/shared/utilsFamily';
import { AMENITIES_DESCRIPTIONS } from '../utils/pricetravel/shared/cardService'
import { getHeaders } from '../utils/pricetravel/shared/tokenUtil';
import { getDepositBanks, getDepositAccountName, getDepositContactEmail } from '../utils/pricetravel/shared/bankUtils';
import LowPriceNotifierService from '../utils/pricetravel/shared/lowPriceNotifierService';
import { formatDate, calculateDateDifference } from '../utils/constants/date';
import { FILTER_URI_LABELS } from '../utils/constants/filterUriLabels';
import FavsTracker from '../MetricsTracker/favorite/metrics';
import { StorageService } from '../vue/services/StorageService'
import { SearchHistory } from '../utils/pricetravel/shared/searchHistory';
import MealPlanNormalizer from '../utils/pricetravel/shared/MealPlanNormalizer';

window.app.controller('ListController', controller);
controller.$inject = ["$scope", "$http", "$q", "$timeout", "$location", "$rootScope", "$filter", "$compile"];

function controller($scope, $http, $q, $timeout, $location, $rootScope, $filter, $compile) {
    let config = window.__pt.settings.site;
    let exchange = window.__pt.exchange;
    let vm = this;
    let anchorLockId = null;
    let scrollToken = 0;
    let fn = window.__pt.fn;
    let userLocation = window.__pt.userLocation;
    let settings = window.__pt.settings;
    let place = window.__pt.place || {};
    let box = window.__pt.box || {};
    let cultureData = window.__pt.cultureData || {};
    let _exchange = window.__pt.exchange || {};
    let hotelResponse = window.__pt.hotelResponse || {};
    let hotelPhones = window.__pt.hotelPhones || {};
    let ln = window.__pt.ln || {};
    let rates = {};
    let currentHotelList = {};
    let skillBase = {};
    let _paxes = {};
    let _size = [2, 1];
    let _separator = "...";
    let _successSkillBase = "200 - OK";
    let _campaignToken = null;
    let __modal = "";
    let _pref = "";
    let _googleMap = null;
    let _devMode = window.__pt.devMode;
    let _user = window.__pt.user || null;
    let _isLogin = !!_user;
    let _paramQuery = fn.search();
    let _listUtil = new ListUtil(_paramQuery, config, _separator);
    let _globalUtil = new GlobalUtil(_paramQuery, config);
    let _userKey = _globalUtil.getUserKey();
    let _userKeyFac = _globalUtil.getUserKeyFavorites();
    let isFirstPageLoad = true;
    let productType = {
        hotel: 1,
        accommodation: 2
    }

    function getSearchModificationCount() {
        return parseInt(StorageService.get('searchModificationCount') || '0', 10);

    }

    let tracker = null;
    let trackerFooter = new FooterTracker();

    let allowRequest = true;
    let isMobile = fn.mobileAndTabletCheck();
    let headerPhoneId = '.header-phonebase';
    let isOpenMap = false;
    let dataRatesFetch = {};
    let disabledCardTargets = ['slick-next', 'slick-prev'];
    let filtersLoaded = false;
    let filtersInitReq = false;
    let retryData = null;
    let responseWithLogin = {
        loaded: false,
        data: {}
    };


    let newPax = matchFamilyRule(box.pax);
    let paramsRates = {
        from: "",
        site: config.domain,
        ids: "",
        countryCode: config.country.toUpperCase(),
        format: false,
        cache: settings.rb,
        CampaignToken: _campaignToken,
        profileId: null,
        placeId: place.id
    }

    let params = {
        culture: cultureData.internalCultureCode,
        pageSize: config.listItemsCount,
        organizationId: config.organization,
        propertyId: config.property,
        getFilters: true,
        filters: null,
        placeId: null,
        currentPage: +box.page,
        page: +box.page,
        site: config.site,
        countryCode: config.country.toUpperCase(),
        format: false,
        cache: settings.rb,
        placeName: place.displayText,
        placeId: place.id,
        checkIn: box.checkIn,
        checkOut: box.checkOut,
        profileId: null,
        filters: null,
        pax: "",
        userType: settings.userType

    }
    let trackerFavs = new FavsTracker();
    let paramsSkillBase = {
        checkInDate: params.checkIn,
        checkOutDate: params.checkOut,
        placeId: place.id,
        adultQuantity: 0,
        kidQuantity: 0,
        hotelId: 0,
        stepId: 2
    };

    //FUNCIONALIDAD HOTELSEARCH
    vm.keyPosition = 0;
    let _list = "";
    vm.suggestionSearchHotel = {
        from: {
            results: [],
            show: false
        }
    };
    vm.placeInputHasFocus = false;

    let hotelIdWithOutRates = null;
    vm.ln = ln;
    vm.showServices = config.showServices;
    vm.code = config.code;
    vm.hotels = [];
    vm.rentals = [];
    vm.filterHotelsOrHouses = [];
    vm.pillPropertTypeFilter = []
    vm.isActive = undefined
    vm.mealplans = MealPlanNormalizer.normalizeAll(ln.mealplans, config.siteName);
    vm.loading = true;
    vm.loadingRefresh = false;
    vm.showMapDetail = false;
    vm.onRendeCenter = false;
    vm.loadingRates = true;
    vm.showAd = false;
    vm.hasError = false;
    vm.mapContent = true;
    vm.notQuote = false;
    vm.filters = [];
    vm.filtersSelectedArray = [];
    vm.filterCustomList = [];
    vm.filtersSelectedArrayString = box.filters || [];
    vm.currency = __pt.settings.site.currencyCodeName;
    vm.currencyList = __pt.settings.site.currencyCodeName;
    vm.currencyFormat = __pt.settings.site.currencyCodeName;
    vm.phoneBase = config.phoneDefault || "";
    vm.profileId = null;
    vm.input_hotel_name = box.hotel_name || "";
    vm.label_hotel_name = box.hotel_name || "";
    vm.title = "";
    vm.monthInterestData = {};
    vm.dataTotalCapacity = 0;
    vm.paxData = {};
    vm.showMapDetailCard = false;
    vm.filterUpDown = false;
    vm.nightsList = 0;
    vm.pricesSelected = [];
    vm.user = _user;
    vm.toggleRange = true;
    vm.rangeApplyState = false;
    vm.toggleOrderBy = false;
    vm.togglePopularFilter = true;
    vm.togglePetFriendlyFilter = true;
    vm.toggleCompositionFilter = true;
    vm.textOrderBy = "";
    vm.limitFilterGroup = 3;
    vm._isLogin = _isLogin;
    vm.popularFilters = null;
    vm.productType = window.__pt.productType;
    _googleMap = new GoogleMapList(vm, $http, $filter, $scope);
    vm.composition = {
        "bedRooms": {
            "max": 1,
            "min": 0
        },
        "bathRooms": {
            "max": 1,
            "min": 0
        },
        "beds": {
            "max": 1,
            "min": 0
        },
        "isPetFriendly": false
    }

    vm.filtersComposition = {
        bedRooms: 1,
        bathRooms: 1,
        beds: 1,
        isPetFriendly: false
    };

    vm.increase = function (field) {
        const max = vm.composition[field]?.max;

        if (max === undefined || vm.filtersComposition[field] < max) {
            vm.filtersComposition[field]++;
            onLoadHotelsFilters();
        }
    };

    vm.decrease = function (field) {

        const min = vm.composition[field]?.min ?? 0;
        if (vm.filtersComposition[field] > min) {
            vm.filtersComposition[field]--;
            onLoadHotelsFilters();
        }
    };

    vm.changeOnPetFriendly = function () {
        onReloadHotels()
    }


    vm.detailCardMap = {
        id: '',
        name: '',
        stars: 0,
        discount: 0,
        cloudUri: '',
        surveyAverage: '',
        highlightedAttributes: '',
        price: '',
        tax: '',
        showPromotion: false,
        highlights: [],
        rooms: 0,
        isFavorite: false,
        services: []
    };

    vm.paramsFilter = {
        cache: false,
        countryCode: config.country.toUpperCase(),
        culture: cultureData.internalCultureCode,
        filters: null,
        hotelName: null,
        pageSize: config.listItemsCount,
        page: +box.page,
        placeId: place.id,
        site: config.domain,
        responseTimeout: 20000,
        totalHotels: hotelResponse.totalHotels,
        totalRentals: hotelResponse.totalRentals,
        productType: window.__pt.productType,
        CampaignToken: _campaignToken,
        userType: settings.userType,
        devMode: _devMode ? _devMode : null,
        petFriendly: false,
        bedMin: 0,
        bedMax: 0,

        bathroomMin: 0,
        bathroomMax: 0,

        bedroomMin: 0,
        bedroomMax: 0,
    }

    vm.config = {
        limitTextHighlight: config.limitTextHighlight,
        limitHighlightElement: config.limitHighlightElement,
    };

    vm.pagination = {
        currentPage: params.page - 1,
        totalPages: 0,
        startPage: 0,
        endPage: 0,
        breaker: 0,
        selected: 0,
        buttons: [],
        render: [],
        pageSize: config.listItemsCount,
        totalHotels: 0
    };
    vm.paramsRoomRates = {};
    vm.responsePayment = {
        fixedPayments: [],
        monthInterestFree: [],
        loading: true
    };

    vm.hotelFilters = {
        loading: true,
        min: 0,
        max: 0,
        filterCustoms: {
            prices: {
                min: 0,
                max: 0
            }
        }

    };

    vm.filterSelection = {
        min: 0,
        max: 0
    }
    
    //favorites
    const service = new LowPriceNotifierService(config.domainAPIUrl);
    vm.alertsFavorites = {
        notificationSuccess: false,
        notificationError: false,
        notificationWarning: false,
        message: "",
        actionType: '',
        type: '' // 'save' or 'delete'
    };
    vm.showTimer = false;
    let notificationTimeout = null;
    vm.favoriteHotels = [];

    vm.onInit = (title, pref) => {


        $('.seo-list-init').css('display', 'none');
        vm.title = $("<div/>").html(title).text();
        _pref = pref;
        _paxes = newPax;
        tracker = new ListTracker(_paxes, params, paramsRates);
        if (_paramQuery.filters) {
            let filtrosToApply = _paramQuery.filters.split(',');
            filtrosToApply.forEach((element, index) => {
                vm.filterCustomList.push({
                    id: 1000 + index,
                    groupId: 0,
                    display: element,
                    uri: element,
                    isSelected: true,
                    categoryGuid: 103,
                    guid: crypto.randomUUID(),
                    total: 30,
                    translate: true
                });
            });
        }
        if (_paramQuery.orderBy) {
            let filtrosToApply = _paramQuery.orderBy.split(',');
            filtrosToApply.forEach((element, index) => {
                vm.paramsFilter.orderBy = element;
            });
        }
        vm.paxData = box.pax;
        vm.dataTotalCapacity = _paxes.adults + _paxes.children;

        syncFiltersFromUrl();

        initializeValues();


        initializeElements();

        showAds();
        if (!settings.rb) {
            vm.getUSersFavorites();
        }
        if (_paramQuery.nearby) {
            vm.showModalMap();
        }
    }

    function syncFiltersFromUrl() {
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(part => part.length > 0);

        const destinationIndex = pathParts.findIndex(part => /_d\d+$/.test(part));

        if (destinationIndex !== -1 && destinationIndex < pathParts.length - 1) {
            const urlFilters = pathParts.slice(destinationIndex + 1);

            urlFilters.forEach(filter => {
                if (!vm.filtersSelectedArrayString.includes(filter)) {
                    vm.filtersSelectedArrayString.push(filter);
                }
            });
        }
    }

    vm.getUSersFavorites = () => {
        const request = { UserId: _userKeyFac, country: config.country.toUpperCase() };

        service.getHotelsByUser(request).then(response => {
            vm.favoriteHotels = response.value;
        }).catch(error => {
            console.error('Error fetching hotels by user:', error);
        });
    }

    //Favorites funciontality
    vm.updateHotelsState = (ismap, hotelId = null) => {
        vm.detailCardMap.isFavorite = vm.isFavoriteHotel(vm.detailCardMap.id);
        vm.hotels.forEach(hotel => {
            $scope.$applyAsync(() => {
                hotel.isFavorite = vm.isFavoriteHotel(hotel.productId);
            });
        });
        if (isOpenMap && hotelId) {
            $timeout(() => {
                _googleMap.updateMarkerFavorite(hotelId);
            });
        } else if (ismap) {
            _googleMap.clearMarkers()
            _googleMap.centerMap();
        }
    };
    vm.renderCurrencyDisplay = function (amount) {
        const childScope = $scope.$new();
        const currencyComponent = `<currency-display amount="${amount}" show-currency-code="true"></currency-display>`;
        const compiledComponent = $compile(currencyComponent)(childScope);
        childScope.$digest();
        const html = compiledComponent[0].outerHTML;
        childScope.$destroy();
        return html;
    };
    vm.addFavorites = function (event, hotel, ismap = false, type) {
        event.preventDefault();
        event.stopPropagation();
        let copyBoxPax = comvertToMain(box.pax);
        const addHotelRequest = {
            productId: ismap ? `${hotel.id}` : `${hotel.productId}`,
            userId: _userKeyFac,
            uri: hotel.uri,
            site: config.domain,
            channel: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
            originalPrice: ismap ? hotel.price > 0 ? hotel.price : 0 : hotel.taxes ? hotel.taxes.totalRoomRatePerNight : 0,
            checkin: params.checkIn,
            checkout: params.checkOut,
            rooms: copyBoxPax.map(pax => ({
                adults: pax.adults,
                children: pax.children.map(child => child.year)
            })),
            campaignToken: _campaignToken || "",
            placeId: place.id,
            placeType: place.type,
            placeUri: place.uri,
            placeName: place.name,
            isMobile: isMobile
        };

        if (vm.isFavoriteHotel(addHotelRequest.productId)) {
            const favoriteId = vm.getFavoriteId(addHotelRequest.productId);
            if (favoriteId) {
                service.removeHotel({ Id: favoriteId, UserId: _userKeyFac }).then(response => {
                    $scope.$applyAsync(() => {
                        vm.favoriteHotels = vm.favoriteHotels.filter(favHotel =>
                            !(favHotel.productId === addHotelRequest.productId &&
                                favHotel.checkin === box.checkIn &&
                                favHotel.checkout === box.checkOut &&
                                angular.equals(comvertToAB(favHotel.rooms), box.pax))
                        );
                        const favoriteHotel = { ...addHotelRequest, id: favoriteId, name: hotel.name };
                        trackerFavs.logDeleteFav(favoriteHotel, 'list');
                        vm.updateHotelsState(ismap, addHotelRequest.productId);
                        vm.showNotification('error', hotel.name, 'delete', type);
                    });
                }).catch(error => {
                    $scope.$applyAsync(() => {
                        vm.showNotification('error', error,'', type);
                    });

                });
            }
        } else {
            // Agregar el hotel a favoritos
            service.addHotel(addHotelRequest).then(response => {
                $scope.$applyAsync(() => {
                    if (response.value) {
                        const favoriteHotel = { ...addHotelRequest, id: response.value, name: hotel.name };
                        vm.favoriteHotels.push(favoriteHotel);
                        trackerFavs.logAddFav(favoriteHotel, 'list');
                        vm.updateHotelsState(ismap, addHotelRequest.productId);
                        vm.showNotification('success', hotel.name, 'save', type);
                    } else {
                        vm.showNotification('warning', '', '', type);
                    }

                });
            }).catch(error => {
                $scope.$applyAsync(() => {
                    vm.showNotification('error', error, '', type);
                });
            });
        }
        _globalUtil.vibrate();

    };

    vm.showNotification = (type, message, actionType, typePlace) => {
        // Cancelar cualquier timeout anterior
        if (notificationTimeout) {
            $timeout.cancel(notificationTimeout);
        }
        vm.showTimer = false;
        $timeout(() => {
            vm.showTimer = true;
        });
        vm.alertsFavorites.notificationSuccess = type === 'success';
        vm.alertsFavorites.notificationError = type === 'error';
        vm.alertsFavorites.notificationWarning = type === 'warning';
        vm.alertsFavorites.message = message;
        vm.alertsFavorites.type = typePlace;
        vm.alertsFavorites.actionType = actionType; // 'save' or 'delete'

        // Ocultar la notificación después de 6 segundos
        notificationTimeout = $timeout(function () {
            vm.alertsFavorites.notificationSuccess = false;
            vm.alertsFavorites.notificationError = false;
            vm.alertsFavorites.notificationWarning = false;
            vm.alertsFavorites.message = "";
            vm.alertsFavorites.typePlace = "";
            vm.alertsFavorites.actionType = '';
        }, 6000);
    };
    vm.getFavoriteId = function (productId) {
        const favorite = vm.favoriteHotels.find(favHotel =>
            favHotel.productId === productId &&
            favHotel.checkin === box.checkIn &&
            favHotel.checkout === box.checkOut &&
            angular.equals(comvertToAB(favHotel.rooms), box.pax)
        );
        return favorite ? favorite.id : null;
    };

    vm.isFavoriteHotel = (productId) => {
        return vm.favoriteHotels.some(favHotel =>
            favHotel.productId === productId &&
            favHotel.checkin === box.checkIn &&
            favHotel.checkout === box.checkOut &&
            angular.equals(comvertToAB(favHotel.rooms), box.pax)
        );
    };
    vm.getGuestsDescription = function (adults, children) {
        var adultsText = adults + ' ' + (adults === 1 ? __pt.ln.adult : __pt.ln.adults);
        var childrenText = children > 0 ? ', ' + children + ' ' + (children === 1 ? __pt.ln.child : __pt.ln.children) : '';
        return adultsText + childrenText;
    };
    vm.titleOfferwow = function (nights, adults, children) {
        return nights + ' ' + (nights > 1 ? __pt.ln.nights : __pt.ln.night) + ' ' + __pt.ln.for + ' ' + vm.getGuestsDescription(adults, children);
    };
    vm.titleOfferResum = function (nights, adults, children, rooms) {
        return nights + ' ' + (nights > 1 ? __pt.ln.nights : __pt.ln.night) + ', ' + rooms + ' ' + (rooms === 1 ? __pt.ln.room : __pt.ln.rooms) + ' ' + __pt.ln.for + ' ' + vm.getGuestsDescription(adults, children);
    };
    vm.getTotalRoomNightsText = function (rooms, nights) {
        var roomText = rooms === 1 ? __pt.ln.room : __pt.ln.rooms;
        var nightText = nights === 1 ? __pt.ln.night : __pt.ln.nights;

        return __pt.ln.total + ' ' + rooms + ' ' + roomText + ' ' + nights + ' ' + nightText + ':';
    };

    vm.slideCarrousel = async (event, hotel, direction) => {
        event.preventDefault();
        if (!hotel.isLoadGallery) {
            hotel.isLoadGallery = false;
            let qr = {
                hotelId: hotel.productId,
                culture: params.culture,
                organizationId: params.organizationId,
                propertyId: params.propertyId,
                imageProfileId: 'desktop',
                productType: hotel.productType
            }

            let response = await $http.get(config.endPoints.galleryDetailUrl, { params: qr });

            hotel.gallery = fn.clone([...response.data.gallery, hotel.mainPhoto]);
            hotel.isLoadGallery = true;
            hotel.galleryPosition = 2;

        }
        hotel.galleryPosition += direction == 'right' ? +1 : -1;

        $timeout(function () {
            hotel.mainPhoto = hotel.gallery[Math.abs((hotel.galleryPosition - 1) % hotel.gallery.length)];
        }, 0);

    }







    vm.callHotelPhone = (event, hotel) => {
        event.preventDefault();
        event.stopPropagation();

        const phone = vm.getPrimaryPhone(hotel.productId, true);
        if (phone) {
            window.location.href = 'tel:' + phone;
        }
    };

    vm.onContactClick = (event, hotel) => {
        event.preventDefault();
        event.stopPropagation();

        const isMobileView = window.innerWidth < 768;

        if (!isMobileView) {
            const phone = vm.getPrimaryPhone(hotel.productId, true);
            if (phone) {
                window.location.href = 'tel:' + phone;
            }
            return;
        }

        const currentState = !!hotel.showContactTooltip;

        vm.hotels && vm.hotels.forEach(h => {
            if (h !== hotel) h.showContactTooltip = false;
        });
        if (vm.detailCardMap && vm.detailCardMap !== hotel) {
            vm.detailCardMap.showContactTooltip = false;
        }

        hotel.showContactTooltip = !currentState;
    };

    document.addEventListener('click', (event) => {
        if (event.target.closest('.new-card__contact')) {
            return;
        }
        $scope.$applyAsync(() => {
            vm.hotels && vm.hotels.forEach(h => h.showContactTooltip = false);
            if (vm.detailCardMap) vm.detailCardMap.showContactTooltip = false;
        });
    });


    vm.areAllServicesNotHighlighted = (services) => {
        if (services.length === 0)
            return false;

        return services.every((service) => {
            return !service.highlited;
        });
    }

    vm.getTitleFilter = (filter, group) => {
        if (group.id == 8 && filter.uri != "sin-categoria-estrellas" && filter.uri != "without-stars-category") {
            return `<i class="font-icons icon-${filter.uri}-star"></i>`
        }

        return filter.display;
    }

    vm.getPropertyTypeLabel = (id) => {

        const text = ln?.propertytypes?.[id] || "";

        const iconMap = {
            "1": "icons-building",               // All suite
            "2": "icons-hotel-regular-full",     // All-Inclusive resort
            "3": "icons-building",               // Apartment
            "4": "icons-coffee",                 // Bed and breakfast
            "7": "icons-mountain",               // Chalet
            "8": "icons-building",               // Condominium
            "16": "icons-home",                  // Guest house
            "20": "icons-hotel-regular-full",    // Hotel
            "22": "icons-mountain",              // Lodge
            "25": "icons-caravan",               // Mobile-home
            "30": "icons-hotel-regular-full",    // Resort
            "33": "icons-tent",                  // Tent
            "34": "icons-house-outline",         // Vacation home
            "35": "icons-house-outline",         // Villa
            "37": "icons-castle",                // Castle
            "63": "icons-building",              // Aparthotel
            "64": "icons-boat",                  // Boat
            "65": "icons-home",                  // Cottage
            "66": "icons-tent",                  // Camping
            "67": "icons-house-outline",         // House
            "68": "icons-door",                  // Private room
            "69": "icons-users",                 // Shared room
            "70": "icons-cabin",                 // Cabin
            "71": "icons-house-outline",         // Bungalow
            "72": "icons-moon",                  // Riad
            "73": "icons-car",                   // RV
            "74": "icons-japan",                 // Ryokan
            "75": "icons-building",              // Loft
            "76": "icons-building"               // Townhouse
        };

        const iconClass = iconMap[id];

        if (iconClass) {
            return `<span class="icon ${iconClass} font-20" aria-hidden="true"></span> <span class="new-card__accommodation-type">${text}</span>`;
        }

        return text;
    };


    vm.getTitleFilterCustom = (filter, group, isPhil = false) => {

        let textSanitize = '';
        if (filter.categoryGuid === 102 && !isPhil) {
            return `<i class="font-icons icon-${filter.uri}-star mt-minus-4"></i>`
        }
        var title_parts = filter.display.split("_");
        let baseTranslate = ln[`${title_parts[0]}`] && ln[`${title_parts[0]}`][`${title_parts[1]}`] ? ln[`${title_parts[0]}`][`${title_parts[1]}`] : filter.display;
        const promoConfig = typeof vm.getFilterPromotionConfig === 'function' ? vm.getFilterPromotionConfig(filter) : null;
        
        if (promoConfig) {
            let text = promoConfig.badgeType;
            const badgeNormalized = promoConfig.badgeType ? promoConfig.badgeType.trim().toLowerCase() : '';
            if (promoConfig.badgeText && typeof promoConfig.badgeText === 'string' && promoConfig.badgeText.trim() !== '') {
                text = promoConfig.badgeText.trim();
            } else if (window.__pt && window.__pt.ln) {
                if (window.__pt.ln.campaigns && window.__pt.ln.campaigns[badgeNormalized]) {
                    text = window.__pt.ln.campaigns[badgeNormalized];
                }
            }
            if (text) {
                baseTranslate = text;
            }
        }
        
        textSanitize = baseTranslate;

        // if (filter.uri === "propertyselection_hotel" || filter.uri === "propertytype_20" || filter.uri === "propertytype_3") {
        //     textSanitize = `<i class="icons-hotel-regular-full padding-icon-flame1"></i> ${textSanitize} `
        // } else if (filter.uri === "propertyselection_accommodation" || filter.uri === "propertytype_67" || filter.uri === "propertytype_35") {
        //     textSanitize = `<i class="icons-house-outline padding-icon-flame1"></i> ${textSanitize}`
        // } else if (FILTER_URI_LABELS[filter.uri]) {
        //     const _lang = config.language === 'es' ? 'es' : 'en';
        //     textSanitize = FILTER_URI_LABELS[filter.uri][_lang];
        // }
        return textSanitize;
    }




    vm.getTitleFilterPopular = (filter) => {

        if (filter.categoryGuid != 0) {
            return vm.getTitleFilterCustom(filter, null);
        } else {
            return vm.getTitleFilter(filter, {})
        }
    }

    vm.onSelectRecommenderDate = (e, item, url) => {
        e.preventDefault();
        e.stopPropagation();

        tracker.selectDateSuggested(item);

        let urlarray = url.split('?');
        let query = fn.searchUri(urlarray[1]);
        query.checkin = item.CheckIn;
        query.checkout = item.CheckOut;

        let baseUrl = urlarray[0];
        const pathParts = baseUrl.split('/');

        if (vm.filtersSelectedArrayString.length > 0) {
            const hotelPath = pathParts[1];
            const destinoPath = pathParts[2];
            const filtrosPath = vm.filtersSelectedArrayString.join("/");
            baseUrl = `/${hotelPath}/${destinoPath}/${filtrosPath}`;
        }

        let queryString = fn.objectToQueryParams(query);
        window.location.href = baseUrl + '?' + queryString;
    }

    vm.onEventMapToDetail = () => {
        tracker.onClickMapToDetail(_paxes);
    };

    vm.getPrimaryPhone = (hotelId, raw = false) => {
        const phones = hotelPhones[hotelId?.toString()];
        if (!phones || !phones.length) return null;
        return raw ? phones[0].phoneBase : phones[0].phoneFormatted;
    };

    vm.formatPhone = (phone) => {
        phone = phone.replace(/\D/g, "");
        return phone.replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3");
    };

    vm.onSelectHotel = (hotel, evt) => {
        const classname = evt.target.className;

        if (classname.includes(disabledCardTargets[0]) || classname.includes(disabledCardTargets[1])) {
            return;
        }

        // Prevent ghost clicks when opening the map card from a marker
        if (vm.mapCardOpenedAt && (Date.now() - vm.mapCardOpenedAt < 500)) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
        }
        
        if (hotel.isAds && hotel.clickToken) {
            if (navigator.sendBeacon) {
                const url = config.endPoints.adsClickUrl;
                if (url) {
                    const data = JSON.stringify({ tokenClic: hotel.clickToken });
                    const blob = new Blob([data], { type: 'application/json' });
                    navigator.sendBeacon(url, blob);
                }
            }
        }

        //$("#loader-page").removeClass("d-none")
        tracker.onClickImpression(hotel);

        if (hotel.productId == +[vm.profileId] && hotel.dateRecommended && hotel.dateRecommended.length > 0) {
            return;
        }
        //history.pushState(null, '', evt.currentTarget.href);
    }

    vm.getRecomendateDatePaxNight = (days) => {
        const nightTitle = days == 1 ? ln.night : ln.nights;
        return `${days} ${nightTitle}`;
    }
    vm.getRecomendateDatePax = (days) => {
        const adultsTitle = newPax.paxes.adults == 1 ? ln.adult : ln.adults;
        const childrenTitle = newPax.paxes.children.length == 1 ? ln.child : ln.children;
        const childrenPart = newPax.paxes.children.length > 0
            ? ` ${ln.and} ${newPax.paxes.children.length} ${childrenTitle}:`
            : ':';
        return `${ln.for} ${newPax.paxes.adults} ${adultsTitle}${childrenPart}`;
    }
    vm.shouldDisplayCard = (hotel) => {
        const isSameHotel = +vm.profileId === +hotel.productId;

        if (isSameHotel) {
            return !(hotel.dateRecommended && hotel.dateRecommended.length > 0);
        }

        return true;

    }

    vm.onSelectDate = (event, hotel, date) => {
        event.preventDefault();
        const { checkin, checkout } = date;
        const url = updateUrlParams(hotel.url, checkin, checkout);
        const newUrl = `${url}`
        window.open(newUrl, '_blank');
    }

    vm.sendContentFooter = (title) => {
        trackerFooter.clickLink(`footer :: ${title}`);
    }

    vm.releaseFocus = () => {
        const active = document.activeElement;

        if (active && typeof active.blur === 'function') {
            active.blur();
        }

        document.body.focus();
    };

    vm.onClosed = (modalId) => {
        const $modal = $(`#${modalId}`);

        vm.releaseFocus();

        $modal.modal('hide');

        $modal.one('hidden.bs.modal', () => {

            const openModals = $('.modal.show').length;

            $('.modal-backdrop').remove();

            if (openModals > 0) {
                $('body').addClass('modal-open');
            } else {
                $('body').removeClass('modal-open');
            }
        });
    };


    vm.onCloseMapCardDetail = (isClosed = false) => {
        if (isClosed && typeof _googleMap !== 'undefined' && _googleMap && Date.now() - (_googleMap.lastSelectionTime || 0) < 500) {
            return;
        }
        var countUp = function () {
            if (isClosed && vm.showMapDetailCard) {
                vm.showMapDetailCard = false;
            } else {
                vm.detailCardMap.show = false;
                vm.showMapDetailCard = false;
                _googleMap.clearBubble();
            }
        }
        $timeout(countUp, 400);

    };

    vm.onEventMapToDetail = () => {
        tracker.onClickMapToDetail(_paxes);
    };

    vm.nextPage = () => {
        _globalUtil.windowScrollTop();
        if (vm.pagination.currentPage < (vm.pagination.totalPages - 1)) {
            vm.pagination.currentPage += 1;
            onReloadHotels()
        }
    }

    vm.prevPage = () => {
        _globalUtil.windowScrollTop();
        if (vm.pagination.currentPage > 0) {
            vm.pagination.currentPage -= 1;
            onReloadHotels()
        }
    }

    vm.selectPage = (page) => {
        _globalUtil.windowScrollTop();
        if (page != _separator) {
            vm.pagination.currentPage = page - 1;
            onReloadHotels();
        }
    }

    vm.onLoadPayment = (modal, btnTitle, btnText) => {
        __modal = modal;
        vm.showModal(__modal, btnTitle, btnText);
        onSearchPaymentMethod();
    }




    vm.activeAnchorId = 'filter-propertytype';

    let scrollContainer;
    let offsetTop;

    $timeout(() => {
        scrollContainer = document.getElementById('filtersScrollContainer');
        if (!scrollContainer) return;

        const header = document.querySelector('.filters-mobile__header');
        const chips = document.querySelector('.filters-mobile__chips-container');

        offsetTop = (header ? header.offsetHeight : 0) + (chips ? chips.offsetHeight : 0);

        scrollContainer.addEventListener('scroll', onScrollMobileFilters);
    }, 0);


    function getSectionTop() {
        const chips = document.querySelector('.filters-mobile__chips-container');
        const chipsOffset = chips ? chips.offsetHeight : 0;
        return function (section) {
            const containerRect = scrollContainer.getBoundingClientRect();
            const sectionRect = section.getBoundingClientRect();
            return sectionRect.top - containerRect.top + scrollContainer.scrollTop - chipsOffset;
        }
    }

    const getTop = getSectionTop();

    function onScrollMobileFilters() {
        if (vm.isProgrammaticScroll) return;

        const sections = scrollContainer.querySelectorAll('.filters-section[data-anchor-id]');
        let currentSectionId = vm.activeAnchorId;
        const offset = 0;

        for (let section of sections) {
            if (scrollContainer.scrollTop >= getTop(section) - offset) {
                currentSectionId = section.dataset.anchorId;
            } else {
                break;
            }
        }

        const scrollBottom =
            scrollContainer.scrollTop + scrollContainer.clientHeight;

        if (scrollBottom >= scrollContainer.scrollHeight - 10) {
            currentSectionId = sections[sections.length - 1].dataset.anchorId;
        }

        if (vm.activeAnchorId !== currentSectionId) {

            if (anchorLockId && currentSectionId !== anchorLockId) {
                return;
            }

            $scope.$applyAsync(() => {
                vm.activeAnchorId = currentSectionId;
                scrollMenuToActive();
            });
        }

    }



    vm.isProgrammaticScroll = false;

    vm.goToAnchor = function (id) {
        const section = document.getElementById(id);
        if (!section) return;

        const chips = document.querySelector('.filters-mobile__chips-container');
        const chipsOffset = chips ? chips.offsetHeight : 0;
        const marginTop = parseInt(getComputedStyle(section).marginTop) || 0;
        const EXTRA_OFFSET = chips ? -35 : 0;

        scrollToken++;
        const myToken = scrollToken;

        vm.isProgrammaticScroll = true;
        vm.activeAnchorId = id;
        anchorLockId = id;

        const sectionTop =
            section.getBoundingClientRect().top
            - scrollContainer.getBoundingClientRect().top;

        scrollContainer.scrollTo({
            top:
                scrollContainer.scrollTop
                + sectionTop
                - chipsOffset
                - marginTop
                - EXTRA_OFFSET,
            behavior: 'smooth'
        });

        let lastScrollTop = scrollContainer.scrollTop;

        const stopCheck = () => {
            if (myToken !== scrollToken) {
                cleanup();
                return;
            }

            const current = scrollContainer.scrollTop;

            if (Math.abs(current - lastScrollTop) < 1) {
                cleanup();
                return;
            }

            lastScrollTop = current;
        };

        const cleanup = () => {
            scrollContainer.removeEventListener('scroll', stopCheck);

            if (myToken === scrollToken) {
                vm.isProgrammaticScroll = false;
                setTimeout(() => {
                    anchorLockId = null;
                }, 100);
            }
        };

        scrollContainer.addEventListener('scroll', stopCheck);
        setTimeout(cleanup, 700);
    };








    function scrollMenuToActive() {
        const menu = document.getElementById('filtersMenu');
        if (!menu) return;

        const activeLink = menu.querySelector('.menu__link--active');
        if (!activeLink) return;

        const menuRect = menu.getBoundingClientRect();
        const linkRect = activeLink.getBoundingClientRect();

        if (linkRect.top < menuRect.top || linkRect.bottom > menuRect.bottom) {
            menu.scrollTo({
                top: activeLink.offsetTop - menu.clientHeight / 2,
                behavior: 'smooth'
            });
        }
    }

    $scope.$on('$destroy', function () {
        if (scrollContainer) scrollContainer.removeEventListener('scroll', onScrollMobileFilters);
    });







    vm.isActive = function (filterGroup) {
        return vm.activeAnchorId === 'filter-' + filterGroup.uri;
    };

    vm.showModal = (modal, btnTitle, btnText) => {

        const $modal = $(`#${modal}`);
        const openedModals = $(".modal.show").length;

        const zIndex = 1050 + (10 * openedModals);
        $modal.css("z-index", zIndex);

        $modal.data("modal-index", openedModals);

        setTimeout(() => {
            const $backdrop = $(".modal-backdrop")
                .not(".modal-stack")
                .first();

            if ($backdrop.length) {
                $backdrop
                    .css("z-index", zIndex - 1)
                    .addClass("modal-stack")
                    .attr("data-modal-index", openedModals);
            }
        }, 0);

        $modal.modal("show");

        if (modal === "modal-payform" || modal === "modal-contact") {
            trackerFooter.selectContent(btnTitle, btnText);
        }

        if (modal === "modal-special-offer" && vm.offerWow && vm.offerWow.initializeMap) {
            $timeout(() => {
                vm.offerWow.initializeMap();
            }, 300);
        }
    };


    vm.hideModalList = (modal) => {
        $(`#${modal}`).modal('hide');
    }

    vm.showModalMap = (modal) => {
        isOpenMap = true;
        tracker.onClickOpenMap(_paxes);
        _googleMap.openMap(params, paramsRates, _paxes, _campaignToken, vm.paramsFilter);

    }

    const FULLSCREEN_SELECTOR = '#map-modal';
    const INTERNAL_SELECTOR = '#filters-mobile';


    $(document).on('shown.bs.modal', '.modal', function () {
        const $modal = $(this);

        if ($modal.is(FULLSCREEN_SELECTOR)) {
            $('.modal-backdrop').remove();
            $('body').addClass('modal-open');
        }
    });


    $(document).on('hidden.bs.modal', '.modal', function () {

        const active = document.activeElement;
        if (active && active.blur) active.blur();

        const openModals = $('.modal.show');

        if (openModals.is(FULLSCREEN_SELECTOR)) {
            $('.modal-backdrop').remove();
            $('body').addClass('modal-open');
            return;
        }

        if (openModals.is(INTERNAL_SELECTOR)) {
            $('body').addClass('modal-open');
            return;
        }

        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
    });





    vm.hideModalMapList = (modal) => {
        isOpenMap = false;
        onReloadHotels();
        $(`#${modal}`).modal("hide");
    }

    vm.allowShowFilter = (category) => {

        return config.filtersDisabled.indexOf(category) == -1
    }

    function comvertToAB(input) {
        return input.reduce((acc, room) => {
            acc.adults += room.adults;
            acc.children = acc.children.concat(room.children.map(age => ({ "year": age })));
            acc.rooms += 1;
            return acc;
        }, { "adults": 0, "children": [], "rooms": 0 });
    }
    function comvertToMain(data) {
        const { adults, children, rooms } = data;

        const adultsPerRoom = Math.floor(adults / rooms);
        const extraAdults = adults % rooms;

        const childrenPerRoom = Math.floor(children.length / rooms);
        const extraChildren = children.length % rooms;

        const result = [];

        let childIndex = 0;

        for (let i = 0; i < rooms; i++) {
            const currentRoomAdults = adultsPerRoom + (i < extraAdults ? 1 : 0);
            const currentRoomChildrenCount = childrenPerRoom + (i < extraChildren ? 1 : 0);
            const currentRoomChildren = [];
            for (let j = 0; j < currentRoomChildrenCount; j++) {
                currentRoomChildren.push({ year: children[childIndex].year });
                childIndex++;
            }

            result.push({
                adults: currentRoomAdults,
                children: currentRoomChildren
            });
        }

        return result;
    }


    /*****
    * 
    * SEARCH HOTELS
    * 
    *****/

    vm.onSearchSearch = (value, list, input, focus) => {
        if (!value || (value && value.length < 3)) {
            return;
        }
        // _inputName = focus;
        _list = list;
        vm.paramsFilter.search = value;
        vm.paramsFilter.hotelName = "";
        $http.get(config.endPoints.searchHotelUrl, {
            params: vm.paramsFilter
        }).then(onSuccessSuggestionSearch, onErrorLog)

    }

    vm.onSelectSearch = (item, type, index, fromHistory = false) => {
        let copyToSearch = vm.input_hotel_name;
        if (item && item.productId == null) {
            vm.paramsFilter.hotelName = item.search;
            vm.input_hotel_name = item.search;
            vm.profileId = null;
        } else {
            vm.paramsFilter.hotelName = null;
            vm.profileId = item.productId;
            vm.paramsFilter.profileId = vm.profileId;
            vm.input_hotel_name = item.name;
        }
        tracker.setEventFilterHotelName(item.productId, copyToSearch, vm.input_hotel_name, place);
        vm.placeInputHasFocus = false;
        onReloadHotelsFilter();

    }
    vm.handleKeyPress = function (event) {
        if ((event.which === 13 || event.keyCode === 13) && (vm.input_hotel_name && vm.input_hotel_name.length >= 3)) {
            vm.paramsFilter.hotelName = vm.input_hotel_name;
            tracker.setEventFilterHotelName("", vm.input_hotel_name, vm.input_hotel_name, place);
            vm.input_hotel_name = vm.input_hotel_name;
            vm.paramsFilter.search = "";
            vm.profileId = null;
            vm.placeInputHasFocus = false;
            onReloadHotelsFilter();
        }

    };

    vm.onRemoveSearch = () => {
        if (vm.profileId != null) {
            vm.profileId = null;
            vm.input_hotel_name = "";
            vm.paramsFilter.profileId = null;
            vm.placeInputHasFocus = false;
            onReloadHotelsFilter();
        } else if (vm.paramsFilter.hotelName) {
            vm.input_hotel_name = "";
            vm.placeInputHasFocus = false;
            vm.paramsFilter.hotelName = null;
            onReloadHotelsFilter();
        } else {
            vm.input_hotel_name = "";
            vm.placeInputHasFocus = false;
        }

    }

    vm.onFocusSearch = (element, input) => {
        if (vm.suggestionSearchHotel[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestionSearchHotel[element]["show"] = true;
                    vm.placeInputHasFocus = true;
                });
            }, 250)
        }
    }

    vm.onClickOutsideSearch = (element, prop) => {
        vm.placeInputHasFocus = false;
        element[prop] = false;
        vm.placeInputHasFocus = false;
    }

    function onSuccessSuggestionSearch(response) {

        const data = response.data || [];
        data.push({
            name: `Buscar "${vm.input_hotel_name}"`,
            hotelId: null,
            search: vm.input_hotel_name
        });
        vm.suggestionSearchHotel[_list]["results"] = data;
        vm.suggestionSearchHotel[_list]["show"] = true;
        vm.placeInputHasFocus = true;
    }

    /*****
     * 
     * Filters
     * 
     *****/
    vm.deleteFilterHotel = (reload = true) => {
        vm.input_hotel_name = "";
        vm.label_hotel_name = "";
        vm.pagination.currentPage = 0;

        if (reload) {
            onReloadHotels();
        }
    }

    vm.filterSelected = (filter) => {
        vm.paramsFilter.page = 1;
        vm.pagination.currentPage = 0;

        let objFiltred = vm.filtersSelectedArray.filter(item => item.groupId != filter.id)

        assignFilters(objFiltred);
        changeTextTitle();
        tracker.selectedFilter(filter.display, filter.uri);
    }

    vm.filterChildSelected = (filter, group) => {

        vm.paramsFilter.page = 1;
        vm.pagination.currentPage = 0;

        if (filter.isMultiselect == false) {
            let objFiltred = vm.filtersSelectedArray.filter(item => item.groupId != filter.groupId);
            objFiltred.push(filter)
            assignFilters(objFiltred);
        } else {
            let position = vm.filtersSelectedArray.find(item => item.id === filter.id);
            let objFiltred = [];
            if (position) {
                objFiltred = vm.filtersSelectedArray.filter(item => item.id != filter.id)
            } else {
                vm.filtersSelectedArray.push(filter)
                objFiltred = vm.filtersSelectedArray
            }
            assignFilters(objFiltred);
        }
        changeTextTitle()
        if (filter.id === 20) {
            var concatNewObject = group.filters.filter(item => item.id === 69);
            vm.filtersSelectedArray.push(concatNewObject[0])
            tracker.selectedFilter(group.display, concatNewObject[0].uri);
        }
        tracker.selectedFilter(group.display, filter.uri);
    }

    vm.filterCustomSelected = (filter, reloadFilters = true) => {

        vm.paramsFilter.page = 1;
        vm.pagination.currentPage = 0;

        filter.isSelected = true;
        filter.filters.forEach(child => child.isSelected = false);

        let filters = vm.filterCustomList.filter(item => item.categoryGuid != filter.id);
        vm.filterCustomList = filters;
        tracker.selectedFilter(filter.display, filter.uri);
        if (vm.pricesSelected.length < 1) {
            vm.resetRangeFilter(false);
        }

        onReloadHotels(reloadFilters);
    }

    vm.isHotelSponsored = (hotel) => {
        return config.hotelsSponsored.some(sponsored => +[sponsored] == +[hotel.productId]) ?? false;
    }

    vm.isFilterSelected = (filter) => {
        return vm.filterCustomList.some(f => f.uri === filter.uri);
    }

    vm.toggleFilter = (filter) => {
        filter.isSelected = !filter.isSelected;
        vm.applyPopularFilter(filter, true);
    };


    vm.filterCustomChildSelected = (filter, group, RELOAD_FILTERS = true) => {
        vm.paramsFilter.page = 1;
        vm.pagination.currentPage = 0;

        if (filter.isSelected) {
            group.isSelected = false;
            if (!group.isMultiselect) {
                group.filters.forEach(child => {
                    if (child !== filter) {
                        child.isSelected = false;
                    }
                });
            }
        }

        let filters = vm.filterCustomList;
        if (!group.isMultiselect) {
            filters = vm.filterCustomList.filter(item => item.categoryGuid != group.id);
        }
        if (filter.isSelected) {
            filters.push(filter);
        } else {
            filters = vm.filterCustomList.filter(item => item.uri != filter.uri);
        }

        if (vm.pricesSelected.length < 1) {
            vm.resetRangeFilter(false);
        }
        vm.filterCustomList = filters;
        tracker.selectedFilter(group.display, filter.uri);
        onReloadHotels(RELOAD_FILTERS);
    }

    vm.deleteFilterArray = () => {
        vm.filtersSelectedArray = [];
        vm.filtersSelectedArrayString = [];
        vm.filterCustomList = [];
        vm.paramsFilter.hotelName = "";
        vm.paramsFilter.search
        vm.input_hotel_name = "";
        vm.paramsFilter.hotelName = null;
        vm.profileId = null;
        vm.paramsFilter.petFriendly = false;
        vm.filtersComposition.beds = 0;
        vm.filtersComposition.bathRooms = 0;
        vm.filtersComposition.bedRooms = 0;
        vm.filtersComposition.isPetFriendly = false;
        vm.deleteFilterHotel(/*reload = */ false);
        vm.resetRangeFilter(/*reload = */ false);


        updatePathFilter();
        onReloadHotels();
    }

    vm.filterPillSelected = (filter) => {
        let objFiltred = vm.filtersSelectedArray.filter(item => item.id != filter.id)
        assignFilters(objFiltred);
    }


    const FILTER_ICON_MAP = {
        mealplans: 'icons-restaurant',
        reviews: 'icons-user-check-solid-full',
        promotion: 'icons-label-right',
        paymentmethods: 'icons-hand-holding-circle-dollar',
        freecancellation: 'icons-memo-circle-check-fill',
        interest: 'icons-spa',
        amenities: 'icons-bell-concierge-fill',
        stars: 'icons-star',
        zones: 'icons-geolocation',
        categoriaestrellas: 'icons-memo-circle-check-fill',
        plancomida: 'icons-restaurant',
        interes: 'icons-spa',
        vistadelahabitacion: 'icons-spa',
        amenidades: 'icons-bell-concierge-fill',
        zonas: 'icons-geolocation',
        bedspreference: 'icons-hotel',
        propertytype: 'icons-house-building-solid',
        amenityaccommodation: 'icons-couch'
    };

    vm.getFilterIconClass = function (uri) {
        if (uri) {
            const cleanUri = uri.replace(/-/g, "");
            return FILTER_ICON_MAP[cleanUri] || 'icons-filter';
        }
        return 'icons-filter';
    };

    vm.filterCustomPillSelected = (filters, index) => {
        if (!filters[index]) return;

        const { display, uri } = filters[index];
        const popularFilter = vm.popularFilters.find(item => item.display === display);

        popularFilter && (popularFilter.isSelected = false);

        vm.filtersSelectedArrayString = vm.filtersSelectedArrayString.filter(f => f !== uri);

        filters.splice(index, 1);
        updateQueryPathFilter();
        onReloadHotels();
    }

    vm.onSubmitFilter = (form) => {
        vm.pagination.currentPage = 0;
        if (vm.hotelFilters.filterCustoms.prices.min != vm.filterSelection.min || vm.hotelFilters.filterCustoms.prices.max != vm.filterSelection.max) {
            setFilterPhillRange();
        }
        onReloadHotels()
    }

    vm.onChangeOrderBy = (order) => {
        vm.paramsFilter.orderBy = order.code;
        vm.textOrderBy = order.display;
        tracker.orderEvent(vm.paramsFilter.orderBy);
        vm.onSubmitFilter();
    }

    vm.closeFiltersMobile = () => {
        vm.onSubmitFilter();
        vm.onClosed("filters-mobile");
    }

    vm.onLoadFilters = (payload) => {

        if (!payload) {
            return;
        }

        const indexOfGroup = payload.findIndex(x => x.id === 3);
        if (indexOfGroup > -1) {
            payload[indexOfGroup].filters = payload[indexOfGroup].filters
                .filter(filter => filter.id === 24 || filter.id === 20 || filter.id === 70)
                .sort((a, b) => {
                    const order = [24, 70, 20];
                    return order.indexOf(a.id) - order.indexOf(b.id);
                });
        }

        vm.filters = setIsSelect(payload) || [];
    }

    vm.filterUpDownSet = (indexGroup) => {
        vm.filters[indexGroup].filterUpDown = !vm.filters[indexGroup].filterUpDown;
    }

    vm.filterUpDownSetCustom = (indexGroup) => {
        vm.hotelFilters.filterCustoms.filterGroups[indexGroup].filterUpDown = !vm.hotelFilters.filterCustoms.filterGroups[indexGroup].filterUpDown;
    }

    vm.renderNameFilter = (isCheckBox, name, index, indexChild) => {
        let childrenPosition = isCheckBox ? `_${indexChild}` : '';
        return `${name}_${index}${childrenPosition}`
    }

    vm.applyPopularFilter = (filter, reloadFilters = true) => {
        if (filter.categoryGuid != 0 && filter.categoryGuid != undefined) {
            let filterCustomGroup = vm.hotelFilters.filterCustoms.filterGroups.find(fgroup => fgroup.id === filter.categoryGuid);
            vm.filterCustomChildSelected(filter, filterCustomGroup, reloadFilters);
        }
        else if (filter.display != null) {
            let filterCustomDisplay = vm.hotelFilters.filterCustoms.filterGroups.find(fgroup => fgroup.display === filter.display);
            vm.filterCustomChildSelected(filter, filterCustomDisplay, reloadFilters);
        }
        else {
            let filterGroup = vm.hotelFilters.filterGroups.find(fgroup => fgroup.id === filter.groupId);
            vm.filterChildSelected(filter, filterGroup);
        }

    }


    vm.resetRangeFilter = (reload = true) => {
        vm.pricesSelected = [];
        vm.paramsFilter.filterPriceMin = undefined;
        vm.paramsFilter.filterPriceMax = undefined;
        vm.filterSelection.min = vm.hotelFilters.filterCustoms.prices.min;
        vm.filterSelection.max = vm.hotelFilters.filterCustoms.prices.max;
        setBoxRangeValue(vm.filterSelection.min, vm.filterSelection.max);

        if (reload) {
            onReloadHotels();
        }
    }


    /*****
     * 
     * Private functions
     * 
     *****/

    function initializeElements() {

        onSuccessPreviewHotels({ data: hotelResponse });

        if (!settings.rb) {
            if (settings.site.siteName == "pricetravel" && userLocation.country == "MX") {
                getSkillBase();
            }
            onSearchPaymentMethod();
            if (!_isLogin) {
                getOfertaWow();
            }
            onLoadHotelsFilters();
        }
    }

    function initializeFilters() {
        allowRequest = false;

        const filters = _paramQuery.filters?.split(',') || [];

        if (filters.length && filters.some(filter => /freecancellation(_allowed)?/.test(filter))) {
            const freeCancellation = vm.hotelFilters?.filterCustoms?.filterGroups?.find(
                group => group?.uri === 'freecancellation'
            );

            const freeCancellationAllowed = freeCancellation?.filters?.find(
                filter => filter?.display === 'freecancellation_allowed'
            );

            if (freeCancellationAllowed) {
                freeCancellationAllowed.isSelected = true;
                vm.filterCustomChildSelected(freeCancellationAllowed, freeCancellation);
            }
        }
    }

    function initializeValues() {
        initialCampaignToken();
        vm.profileId = _paramQuery.profileId || _paramQuery.ProfileId || _paramQuery.profileid || null;

        if (isMobile) {
            params.pageSize = config.listItemsMobileCount;
        }
    }

    function initialCampaignToken() {
        let campaignTokenApi = _paramQuery.campaignTokenApi || _paramQuery.CampaignTokenApi || _paramQuery.campaigntokenapi || null;
        _campaignToken = _paramQuery.CampaignToken || _paramQuery.campaignToken || campaignTokenApi;

        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        }
    }

    vm.initializeSliders = initializeSliders;
    function initializeSliders(filterPrice, accommodations) {

        let minValue = vm.paramsFilter.filterPriceMin || filterPrice.min;
        let maxValue = vm.paramsFilter.filterPriceMax || filterPrice.max;
        if (vm.pricesSelected.length === 0 && filterPrice.min && filterPrice.max) {
            minValue = filterPrice.min;
            maxValue = filterPrice.max;
        }

        initializeNativePriceRanges(filterPrice, minValue, maxValue, accommodations);

        if (!vm.paramsFilter.filterPriceMin && !vm.paramsFilter.filterPriceMax) {
            vm.filterSelection.min = minValue;
            vm.filterSelection.max = maxValue;
        }

        if (vm.pricesSelected.length && (vm.filterSelection.max <= filterPrice.max)) {
            setBoxRangeValue(vm.filterSelection.min, vm.filterSelection.max);
        } else {
            setBoxRangeValue(filterPrice.min, filterPrice.max);
        }

        if (vm.filterSelection.min < filterPrice.min || vm.filterSelection.max > filterPrice.max) {
            vm.paramsFilter.filterPriceMin = undefined;
            vm.paramsFilter.filterPriceMax = undefined;
            vm.filterSelection.min = filterPrice.min;
            vm.filterSelection.max = filterPrice.max;
        }

        updateNativePriceRanges(vm.filterSelection.min, vm.filterSelection.max);

        $('.min_slider_box').off('.priceRange').on('keyup.priceRange', (e) => { onKeyupSliderBox(e, 'min') });
        $('.max_slider_box').off('.priceRange').on('keyup.priceRange', (e) => { onKeyupSliderBox(e, 'max') });
        $('.min_slider_box').off('.priceRangeChange').on('change.priceRangeChange', (e) => { onChangeSliderBox(e, 'min') });
        $('.max_slider_box').off('.priceRangeChange').on('change.priceRangeChange', (e) => { onChangeSliderBox(e, 'max') });

    }

    function initializeNativePriceRanges(filterPrice, minValue, maxValue, accommodations) {
        document.querySelectorAll('[data-price-range]').forEach(function (range) {
            const minInput = range.querySelector('.price-range__input--min');
            const maxInput = range.querySelector('.price-range__input--max');
            const nativeMin = Number(filterPrice.min);
            const nativeMax = Number(filterPrice.max);
            const sliderMax = 1000;

            [minInput, maxInput].forEach(function (input) {
                input.min = 0;
                input.max = sliderMax;
                input.step = 1;
            });

            range._priceLimits = { min: nativeMin, max: nativeMax };
            range._priceSliderMax = sliderMax;
            renderPriceHistogram(range, accommodations, filterPrice);

            if (!range._priceRangeInitialized) {
                range.querySelector('.price-range__chart').addEventListener('pointerdown', function (event) {
                    if (!event.target.closest('.price-range__input')) {
                        moveNativePriceHandleFromPointer(range, event);
                    }
                });
                minInput.addEventListener('pointerdown', function (event) {
                    beginNativePriceHandleDrag(range, event, 'min');
                });
                maxInput.addEventListener('pointerdown', function (event) {
                    beginNativePriceHandleDrag(range, event, 'max');
                });
                minInput.addEventListener('focus', function () {
                    setActiveNativePriceHandle(range, 'min');
                });
                maxInput.addEventListener('focus', function () {
                    setActiveNativePriceHandle(range, 'max');
                });
                minInput.addEventListener('input', function () {
                    changeNativePriceRange(range, 'min');
                });
                maxInput.addEventListener('input', function () {
                    changeNativePriceRange(range, 'max');
                });
                minInput.addEventListener('change', function () {
                    commitNativePriceRange(range);
                });
                maxInput.addEventListener('change', function () {
                    commitNativePriceRange(range);
                });
                range._priceRangeInitialized = true;
            }

            updateNativePriceRange(range, minValue, maxValue);
        });
    }

    function beginNativePriceHandleDrag(range, event, defaultHandle) {
        if (!range.classList.contains('price-range--handles-close')) {
            setActiveNativePriceHandle(range, defaultHandle);
            return;
        }

        event.preventDefault();
        const startX = event.clientX;
        let activeHandle = null;

        function moveHandle(moveEvent) {
            const distance = moveEvent.clientX - startX;
            if (!activeHandle && Math.abs(distance) < 2) {
                return;
            }

            activeHandle = distance < 0 ? 'min' : 'max';
            const track = range.querySelector('.price-range__track');
            const bounds = track.getBoundingClientRect();
            const ratio = Math.max(0, Math.min(1, (moveEvent.clientX - bounds.left) / bounds.width));
            const input = range.querySelector('.price-range__input--' + activeHandle);

            input.value = Math.round(ratio * range._priceSliderMax);
            setActiveNativePriceHandle(range, activeHandle);
            changeNativePriceRange(range, activeHandle);
            moveEvent.preventDefault();
        }

        function finishHandleDrag() {
            document.removeEventListener('pointermove', moveHandle);
            document.removeEventListener('pointerup', finishHandleDrag);
            document.removeEventListener('pointercancel', finishHandleDrag);

            if (activeHandle) {
                commitNativePriceRange(range);
            }
        }

        document.addEventListener('pointermove', moveHandle, { passive: false });
        document.addEventListener('pointerup', finishHandleDrag);
        document.addEventListener('pointercancel', finishHandleDrag);
    }

    function moveNativePriceHandleFromPointer(range, event) {
        const track = range.querySelector('.price-range__track');
        const minInput = range.querySelector('.price-range__input--min');
        const maxInput = range.querySelector('.price-range__input--max');
        const bounds = track.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
        const value = Math.round(ratio * range._priceSliderMax);
        const min = Number(minInput.value);
        const max = Number(maxInput.value);
        let handle;

        if (value <= min) {
            handle = 'min';
        } else if (value >= max) {
            handle = 'max';
        } else {
            handle = value - min <= max - value ? 'min' : 'max';
        }

        const input = handle === 'min' ? minInput : maxInput;
        input.value = value;
        setActiveNativePriceHandle(range, handle);
        commitNativePriceRange(range);
    }

    function priceToSliderValue(range, price) {
        const limits = range._priceLimits;
        const clampedPrice = Math.max(limits.min, Math.min(limits.max, Number(price)));
        const logarithmicRange = Math.log(limits.max / limits.min);
        if (limits.min <= 0 || logarithmicRange <= 0) {
            return 0;
        }

        return Math.round((Math.log(clampedPrice / limits.min) / logarithmicRange) * range._priceSliderMax);
    }

    function sliderValueToPrice(range, sliderValue) {
        const limits = range._priceLimits;
        const position = Math.max(0, Math.min(range._priceSliderMax, Number(sliderValue)));
        const logarithmicRange = Math.log(limits.max / limits.min);
        if (position <= 0 || limits.min <= 0 || logarithmicRange <= 0) {
            return limits.min;
        }
        if (position >= range._priceSliderMax) {
            return limits.max;
        }

        return Math.round(limits.min * Math.exp((position / range._priceSliderMax) * logarithmicRange));
    }

    function getNativePriceRangeValues(range) {
        const minInput = range.querySelector('.price-range__input--min');
        const maxInput = range.querySelector('.price-range__input--max');
        return [
            sliderValueToPrice(range, minInput.value),
            sliderValueToPrice(range, maxInput.value)
        ];
    }

    function commitNativePriceRange(range) {
        onChangeWithReloadRangePrice(getNativePriceRangeValues(range));
    }

    function getHotelNightlyPrice(hotel) {
        const candidates = [
            hotel && hotel.taxes && hotel.taxes.totalRoomRatePerNight,
            hotel && hotel.totalRoomRatePerNight,
            hotel && hotel.pricePerNight,
            hotel && hotel.price
        ];
        const price = candidates.map(Number).find(Number.isFinite);

        return Number.isFinite(price) && price > 0 ? price * exchange.rate : null;
    }

    function renderPriceHistogram(range, accommodations, filterPrice) {
        const bars = range.querySelectorAll('.price-range__histogram:not(.price-range__histogram--selected) span');
        const selectedBars = range.querySelectorAll('.price-range__histogram--selected span');
        const bucketCount = bars.length;
        const span = filterPrice.max - filterPrice.min;
        const hasApiDistribution = Array.isArray(filterPrice.distribution) && filterPrice.distribution.length === bucketCount;
        const buckets = hasApiDistribution ? filterPrice.distribution.slice() : Array(bucketCount).fill(0);

        if (!bucketCount || span <= 0 || filterPrice.min <= 0) {
            return;
        }

        if (!hasApiDistribution) {
            (accommodations || []).forEach(function (hotel) {
                const price = getHotelNightlyPrice(hotel);
                if (price === null || price < filterPrice.min || price > filterPrice.max) {
                    return;
                }

                const position = Math.log(price / filterPrice.min) / Math.log(filterPrice.max / filterPrice.min);
                const bucket = Math.min(bucketCount - 1, Math.floor(position * bucketCount));
                buckets[bucket] += 1;
            });
        }

        const largestBucket = Math.max.apply(null, buckets);
        const singleResultHeight = largestBucket > 0
            ? Math.max(8, Math.sqrt(1 / largestBucket) * 100)
            : 0;
        const emptyBucketHeight = Math.min(10, singleResultHeight * 0.6);

        buckets.forEach(function (count, index) {
            const numericCount = Math.max(0, Number(count) || 0);
            const height = largestBucket <= 0
                ? 0
                : numericCount > 0
                    ? Math.max(8, Math.sqrt(numericCount / largestBucket) * 100)
                    : emptyBucketHeight;
            bars[index].style.setProperty('--bar-height', height + '%');
            selectedBars[index].style.setProperty('--bar-height', height + '%');
        });
    }

    function updatePriceHistograms(accommodations) {
        const filterPrice = vm.hotelFilters && vm.hotelFilters.filterCustoms && vm.hotelFilters.filterCustoms.prices;
        if (!filterPrice || filterPrice.max <= filterPrice.min) {
            return;
        }

        document.querySelectorAll('[data-price-range]').forEach(function (range) {
            renderPriceHistogram(range, accommodations, filterPrice);
        });
    }

    function setActiveNativePriceHandle(range, handle) {
        range._activePriceHandle = handle;
        updateNativePriceHandleOrder(range);
    }

    function updateNativePriceHandleOrder(range) {
        const minInput = range.querySelector('.price-range__input--min');
        const maxInput = range.querySelector('.price-range__input--max');
        const min = Number(minInput.value);
        const max = Number(maxInput.value);
        const trackWidth = range.querySelector('.price-range__track').clientWidth;
        const closeThreshold = trackWidth > 0 ? (20 / trackWidth) * range._priceSliderMax : 0;
        let activeHandle = range._activePriceHandle || 'min';

        range.classList.toggle('price-range--handles-close', max - min <= closeThreshold);

        if (min === max && min <= 0) {
            activeHandle = 'max';
        } else if (min === max && max >= range._priceSliderMax) {
            activeHandle = 'min';
        }

        minInput.style.zIndex = activeHandle === 'min' ? 4 : 3;
        maxInput.style.zIndex = activeHandle === 'max' ? 4 : 3;
    }

    function changeNativePriceRange(range, changedHandle) {
        const minInput = range.querySelector('.price-range__input--min');
        const maxInput = range.querySelector('.price-range__input--max');
        let minPosition = Number(minInput.value);
        let maxPosition = Number(maxInput.value);

        if (minPosition > maxPosition) {
            if (changedHandle === 'min') {
                minPosition = maxPosition;
                minInput.value = minPosition;
            } else {
                maxPosition = minPosition;
                maxInput.value = maxPosition;
            }
        }

        onChangeRangePrice(getNativePriceRangeValues(range));
    }

    function updateNativePriceRange(range, min, max) {
        const limits = range._priceLimits;
        if (!limits) {
            return;
        }

        const minInput = range.querySelector('.price-range__input--min');
        const maxInput = range.querySelector('.price-range__input--max');
        const minPosition = priceToSliderValue(range, min);
        const maxPosition = priceToSliderValue(range, max);
        const start = (minPosition / range._priceSliderMax) * 100;
        const end = (maxPosition / range._priceSliderMax) * 100;

        minInput.value = minPosition;
        maxInput.value = maxPosition;
        minInput.setAttribute('aria-valuetext', Math.round(min) + ' ' + vm.currency);
        maxInput.setAttribute('aria-valuetext', Math.round(max) + ' ' + vm.currency);
        range.style.setProperty('--range-start', Math.max(0, Math.min(100, start)) + '%');
        range.style.setProperty('--range-end', Math.max(0, Math.min(100, end)) + '%');
        updateNativePriceHandleOrder(range);
    }

    function updateNativePriceRanges(min, max) {
        document.querySelectorAll('[data-price-range]').forEach(function (range) {
            updateNativePriceRange(range, min, max);
        });
    }

    function onReloadHotels(reloadFilters = true) {
        _globalUtil.windowScrollTop();
        if (isOpenMap) {
            setTimeout(() => {
                _googleMap.initialize();
            }, 0);
            return;
        }
        params.page = vm.pagination.currentPage + 1;
        vm.paramsFilter.page = vm.pagination.currentPage + 1;

        if (reloadFilters) {
            onLoadHotelsFilters();
        }
    }

    function updateQueryPathFilter() {
        const path = window.location.pathname;
        let search = window.location.search;
        const pathSplit = path.split("/");

        search = updateSearch(search);
        const hotel = pathSplit[1];
        const destino = pathSplit[2];
        let filtros = "";
        if (vm.filtersSelectedArrayString.length) {
            filtros = `/${vm.filtersSelectedArrayString.join("/")}`;
        }
        const url = `/${hotel}/${destino}${filtros}`

        window.history.pushState(null, "any", url);
    }


    function updateHotelTags(groupHotels) {
        groupHotels.forEach(hotels => {
            hotels.forEach(hotel => {
                if (hotel.services && Array.isArray(hotel.services)) {
                    hotel.services = hotel.services
                        .map(tag => findReviewByText(tag.name))
                        .filter(Boolean)
                        .sort((a, b) => a.order - b.order)
                        .reduce((acc, current) => {
                            if (!acc.some(service => service.order === current.order)) {
                                acc.push(current);
                            }
                            return acc;
                        }, [])
                        .slice(0, 3)
                        .map(service => {
                            if (service.order === 1) {
                                service.text = 'Wi-fi';
                            }
                            return service;
                        });
                }
            });
        });
    }

    function findReviewByText(text) {
        for (const [key, review] of Object.entries(AMENITIES_DESCRIPTIONS)) {
            if (review.es.includes(text) || review.en.includes(text)) {
                return {
                    key,
                    text: config.language === "es" ? review.es : review.en,
                    ...review
                };
            }
        }
        return null;
    }

    function getSkillBase() {
        paramsSkillBase.adultQuantity = _paxes.adults;
        paramsSkillBase.kidQuantity = _paxes.children;
        paramsSkillBase.checkInDate = params.checkIn;
        paramsSkillBase.checkOutDate = params.checkOut;
        paramsSkillBase.site = config.domain;
        paramsSkillBase.placeId = params.placeId;
        paramsSkillBase.hotelId = 0;
        paramsSkillBase.stepId = "hotel-list";
        paramsSkillBase.device = isMobile ? "mobile" : "desktop"
        paramsSkillBase.product = "hotel";
        paramsSkillBase.source = _paramQuery.source ? _paramQuery.source : "";
        paramsSkillBase.user = __pt.user ? "user" : "anonymous";
        paramsSkillBase.country = __pt.culture.country;
        paramsSkillBase.login = _isLogin;

        $http.get(config.endPoints.skillBaseUrl, { params: paramsSkillBase }).then(onSuccessSkillBase, onErrorLog);
    }

    function getAvailabilityReasons(idHotel) {

        let payload = {
            rid: [idHotel],
            checkin: box.checkIn,
            checkout: box.checkOut,
            p: _globalUtil.getPaxToMessages(newPax)
        };

        $http.post(config.endPoints.availabilityReasonsUrl, payload).then(onSuccessAvailabilityReasons, onErrorLog);
    }

    function getRecommendedDates(idhotel, reasons) {

        let qr = {
            checkIn: box.checkIn,
            checkOut: box.checkOut,
            availabilityReasons: reasons,
            idHotel: idhotel,
            channelId: config.channelFac,
            token: paramsRates.CampaignToken ? paramsRates.CampaignToken : "",
            adults: _paxes.adults,
            kids: _paxes.children,
            providerId: 1,
            placeIdDestination: place.id,
            kidsAge: _globalUtil.getAgeKids(box)
        };

        $http.post(config.endPoints.recommenderDatesUrl, qr).then(onRenderRecomendedDates, onErrorLog);
    }

    function onSearchPaymentMethod() {
        if (vm.responsePayment.fixedPayments.length || vm.responsePayment.monthInterestFree.length) { return; }
        let params = {
            channel: settings.site.channel,
            language: cultureData.internalCultureCode,
            currency: settings.site.currency,
            isdeposit: true
        }
        $http.get(settings.site.endPoints.paymentMethodUrl, { params: params }).then(onSuccessPaymentMethods, onErrorLog)

    }

    function loadFilters(payload) {

        if (!payload) {
            return;
        }

        const indexOfGroup = payload.findIndex(x => x.id === 3);
        if (indexOfGroup > -1) {
            payload[indexOfGroup].filters = payload[indexOfGroup].filters
                .filter(filter => filter.id === 24 || filter.id === 20 || filter.id === 70)
                .sort((a, b) => {
                    const order = [24, 70, 20];
                    return order.indexOf(a.id) - order.indexOf(b.id);
                });
        }
        vm.filters = setIsSelect(payload) || [];
    }

    function loopHotels(filterResponse) {

        let lengthHotel = vm.hotels.length;
        let pax = fn.mapPaxToUrl(box.pax);
        let paxIsRequote = fn.mapPaxToUrl(newPax.paxes);
        let query = "";
        let queryIsRequote = "";
        let paramsUri = {
            checkin: box.checkIn,
            checkout: box.checkOut,
            source: _paramQuery.source ? _paramQuery.source : "",
            promotions: _paramQuery.promotions
        };
        let checkIn = fn.getDate(box.checkIn);
        let checkOut = fn.getDate(box.checkOut);
        let nights = fn.diffBetweenDays(checkIn, checkOut);


        if (_campaignToken) {
            paramsUri.CampaignToken = _campaignToken;
        }
        if (_paramQuery.coupon) {
            paramsUri.coupon = _paramQuery.coupon;
        }

        let paramsUriConcat = { ...paramsUri, ...pax };
        let paramsUriConcatRequote = { ...paramsUri, ...paxIsRequote };

        query = fn.objectToQueryParams(paramsUriConcat);
        queryIsRequote = fn.objectToQueryParams(paramsUriConcatRequote);

        for (let i = 0; i < lengthHotel; i++) {
            let hotel = vm.hotels[i];
            let queryCurrent = hotel.isRequote ? queryIsRequote : query;
            let indexHotelPla = config.hotelsIdsPR ? config.hotelsIdsPR.find(x => x == hotel.productId) : -1;

            hotel.url = _listUtil.getUrlToDetail(hotel, queryCurrent);
            hotel.position = (vm.pagination.currentPage * vm.pagination.pageSize) + i + 1;
            hotel.page = vm.pagination.currentPage + 1;
            hotel.rooms = hotel.isRequote ? paxIsRequote.rooms : pax.rooms;
            hotel.nights = nights;
            hotel.notAmount = config.hotelsTagLogin ? config.hotelsTagLogin.listA.includes(hotel.productId) : false;// LIST A Mensaje sin monto.
            hotel.notMessage = config.hotelsTagLogin ? config.hotelsTagLogin.listB.includes(hotel.productId) : false;// LIST B Sin mensaje.
            hotel.isLoading = filterResponse //mostrar el skeleton cuando no tenga tarifa cargada de filtros
            hotel.sourceTriGooHotelsIds = indexHotelPla > -1;
            hotel.isFavorite = false;
            hotel.skeleton = generateRandomSkeleton();

            if (hotel.taxes) {
                hotel.taxes.feesAmountTotal = config.feesIncludes ? hotel.taxes?.breakdown?.breakDowns
                    .filter(fee => config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;

                hotel.taxes.feesAmountTotalForNight = config.feesIncludes ? hotel.taxes.feesAmountTotal / hotel.nights : 0;
            }


            if (window.__pt && Array.isArray(window.__pt.campaings)) {
                window.__pt.campaings.forEach(campaign => {
                    if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(hotel.productId))) {
                        hotel.campaignObj = Object.assign({}, campaign, { badgeType: campaign.badgeType.trim().toLowerCase() });
                    }
                });
            }
        }
        window.__pt.hotels = vm.hotels;
    }



    function matchHotelWithRate() {
        let lengthHotel = vm.hotels.length;
        for (let i = 0; i < lengthHotel; i++) {
            let hotel = vm.hotels[i];
            hotel.price = null;
            hotel.taxes = null;
            hotel.isRequote = false;
            var prefix = hotel.productType == productType.hotel ? "h" : "a"

            if (rates && rates.rates && rates.rates[`${prefix}${hotel.productId}`]) {
                hotel.price = rates.rates[`${prefix}${hotel.productId}`];
            }

            if (rates && rates.tax && rates.tax[`${prefix}${hotel.productId}`]) {
                hotel.taxes = rates.tax[`${prefix}${hotel.productId}`];
                hotel.isRequote = hotel.taxes.isRequote ? true : false;
                hotel.taxes.feesAmountTotal = config.feesIncludes ? hotel.taxes?.breakdown?.breakDowns
                    .filter(fee => config.breakDownExcludedList.includes(fee.title))
                    .reduce((acc, fee) => acc + fee.amount, 0) : 0;
                hotel.taxes.feesAmountTotalForNight = config.feesIncludes ? hotel.taxes.feesAmountTotal / hotel.nights : 0;
            }

        }
    }

    function onLoadRates() {
        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }

        vm.nightsList = box.pax.length || 0;

        let hotelsId = _listUtil.getHotelOrAccomodationsIds(vm.hotels, productType.hotel);
        let accommodationIds = _listUtil.getHotelOrAccomodationsIds(vm.hotels, productType.accommodation);
        paramsRates.hotelIds = hotelsId.join(",");
        paramsRates.accommodationIds = accommodationIds.join(",");
        paramsRates.rooms = newPax.paxesFormat;
        paramsRates.CampaignToken = _campaignToken;
        paramsRates.profileId = vm.profileId;
        paramsRates.userKey = _userKey;
        paramsRates.mobile = isMobile;
        paramsRates.responseTimeout = 30000;
        paramsRates.checkIn = params.checkIn;
        paramsRates.checkOut = params.checkOut;
        paramsRates.login = _isLogin;
        paramsRates.source = box.source ? box.source : "SPA-Hotel-List";
        paramsRates.filters = vm.filtersSelectedArrayString.join(",");
        paramsRates.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;

        setInfoRooms(paramsRates, box.pax);
        $http.get(config.endPoints.quoteListAccommodationUrl, { params: paramsRates, headers: getHeaders() }).then(onLoadRatesRequote, onErrorRates);
    };

    function onLoadRatesPreLogin() {
        let hotelsId = Array.from(new Set(_listUtil.getHotelOrAccomodationsIds(vm.hotels, productType.hotel)));
        let accommodationIds = Array.from(new Set(_listUtil.getHotelOrAccomodationsIds(vm.hotels, productType.accommodation)));
        if (!settings.rb && hotelsId.length > 0) {
            let paramsLogin = {
                ...paramsRates,
                hotelIds: hotelsId.join(","),    // ahora sin duplicados
                accommodationIds: accommodationIds.join(","),
                CampaignToken: null,
                userKey: null,
                login: !_isLogin,
                channelId: isMobile
                    ? (config.channelConfigDefault?.mobileLogin.channelId || paramsRates.channelId)
                    : (config.channelConfigDefault?.desktopLogin.channelId || paramsRates.channelId)
            };

            $http.get(config.endPoints.quoteListAccommodationUrl, {
                params: paramsLogin,
                headers: getHeaders()
            }).then(onSuccessLoadRatesWithLogin, onErrorLog);
        }

    };
    function updateUrlParams(url, newCheckin, newCheckout) {
        const urlObj = new URL(url);
        const paxes = fn.mapPaxToUrl(newPax.paxes);

        if (vm.filtersSelectedArrayString.length > 0) {
            const pathParts = urlObj.pathname.split('/');

            const hasDestination = pathParts.some(part => part.includes('_d'));

            if (hasDestination) {
                const destinationIndex = pathParts.findIndex(part => part.includes('_d'));

                const basePathParts = pathParts.slice(0, destinationIndex + 1);

                const newPath = basePathParts.concat(vm.filtersSelectedArrayString).join('/');
                urlObj.pathname = newPath;
            }
        }

        //urlObj.searchParams.set('isFromDateRecommended', true);
        urlObj.searchParams.set('checkin', newCheckin);
        urlObj.searchParams.set('checkout', newCheckout);

        for (const [key, value] of Object.entries(paxes)) {
            urlObj.searchParams.set(key, value);
        }

        return urlObj.toString();
    }


    function onLoadHotelsFilters() {

        if (_user && _user.firebaseId) {
            _campaignToken = config.campaignTokenUser;
        } else {
            initialCampaignToken();
        }

        let pax = newPax.paxesFormat.map(item => {
            if (!item.includes('|') && /^[0-9]+$/.test(item)) {
                item += '/n';
            }
            let replacedItem = item.replace(/\|/g, '/');
            return replacedItem;
        }).join('/');

        vm.hotelFilters.error = false;
        vm.hotelFilters.loading = true;
        vm.paramsFilter.pax = `/${pax}`;
        vm.paramsFilter.channel = config.channelFac;
        vm.paramsFilter.channelId = config.channelFac;
        vm.paramsFilter.checkIn = params.checkIn;
        vm.paramsFilter.checkOut = params.checkOut;
        vm.paramsFilter.profileId = vm.profileId;
        vm.paramsFilter.CampaignToken = _campaignToken;
        vm.paramsFilter.login = _isLogin
        vm.paramsFilter.mobile = isMobile;
        vm.paramsFilter.filters = vm.filtersSelectedArrayString.join(",");
        vm.paramsFilter.filtersCustom = vm.filterCustomList.map(f => f.uri).join(",");
        vm.paramsFilter.userKey = _userKey;
        vm.paramsFilter.source = box.source ? box.source : "SPA-Hotel-List";
        vm.paramsFilter.searchDatesRecommended = true;
        vm.paramsFilter.uriPlace = hotelResponse.place.uri;
        vm.paramsFilter.applicable = true;
        vm.paramsFilter.promotions = $location.search().promotions ? $location.search().promotions.split(',') : null;
        vm.paramsFilter.bedMax = +vm.filtersComposition.beds;
        vm.paramsFilter.bathroomMax = +vm.filtersComposition.bathRooms;
        vm.paramsFilter.bedroomMax = +vm.filtersComposition.bedRooms;
        vm.paramsFilter.isPetFriendly = vm.filtersComposition.isPetFriendly;

        let paramsFilter = { ...vm.paramsFilter };
        if (paramsFilter.filterPriceMax) {
            paramsFilter.filterPriceMax = paramsFilter.filterPriceMax / exchange.rate;
        }

        if (paramsFilter.filterPriceMin) {
            paramsFilter.filterPriceMin = paramsFilter.filterPriceMin / exchange.rate;
        }

        if (box.isDefault) {
            paramsFilter.isOrganicTraffic = true;
        }

        if (filtersLoaded) {
            vm.loading = true;
        }

        $http.get(config.endPoints.filterUrl, { params: paramsFilter, loginFlag: _isLogin, headers: getHeaders() }).then(onSuccessFilterResponse, onErrorHotelsFilters);
    }
    function getOfertaWow(isRequote = false) {
        if (vm.offerWow && !isRequote) {
            return;
        }

        vm.paramsRoomRates = {};
        vm.paramsRoomRates.checkIn = params.checkIn;
        vm.paramsRoomRates.checkOut = params.checkOut;
        vm.paramsRoomRates.rooms = newPax.paxesFormat;
        vm.paramsRoomRates.userKey = _userKey;
        vm.paramsRoomRates.culture = cultureData.internalCultureCode;
        vm.paramsRoomRates.responseTimeout = 20000;
        vm.paramsRoomRates.source = box.source ? box.source : "SPA-Hotel-List";
        vm.paramsRoomRates.channelId = isMobile ? config.chkSourceMobile : config.chkSourceDesktop;
        vm.paramsRoomRates.site = config.domain;
        vm.paramsRoomRates.placeId = place.id;
        vm.paramsRoomRates.loading = true;
        setInfoRooms(vm.paramsRoomRates, box.pax);
        $http.get(config.endPoints.offerWowUrl, { params: vm.paramsRoomRates, headers: getHeaders() }).then(onSuccessOfertaWow, onErrorLog);
    }

    function onSuccessAvailabilityReasons({ data }) {
        console.log(data);
    }

    function generateRandomSkeleton() {
        const getRandom = (max = 165, min = 80) => Math.floor(Math.random() * (max - min + 1)) + min;
        return {
            skeleton1: getRandom(130, 115) + "px",
            skeleton2: getRandom(120, 100) + "px",
            skeleton3: getRandom(150, 135) + "px",
            skeleton4: getRandom(95, 80) + "px",
            skeleton5: getRandom(110, 100) + "px",
        };
    }
    /***
     * 
     *  Filters
     */

    function assignFilters(objFiltred) {
        vm.filtersSelectedArray = objFiltred;
        vm.filtersSelectedArrayString = objFiltred.map(item => item.uri);
        updatePathFilter();

        if (vm.pricesSelected.length < 1) {
            vm.resetRangeFilter(false);
        }

        onReloadHotelsFilter();
        _globalUtil.windowScrollTop();
    }

    function onReloadHotelsFilter() {

        if (isOpenMap) {
            return _googleMap.initialize();
        }

        params.page = 1;
        onLoadHotelsFilters();
    }

    function updatePathFilter() {
        const path = window.location.pathname;
        let search = window.location.search;
        const pathSplit = path.split("/");

        search = updateSearch(search);
        const hotel = pathSplit[1];
        const destino = pathSplit[2];
        let filtros = "";
        if (vm.filtersSelectedArrayString.length) {
            filtros = `/${vm.filtersSelectedArrayString.join("/")}`;
        }
        const url = `/${hotel}/${destino}${filtros}${search}`

        window.history.pushState(null, "any", url);

        applyUrlFilters();
    }

    function applyUrlFilters() {
        if (!isFirstPageLoad) {
            return;
        }

        const filterMappingDictionary = {
            'plan-todo-incluido': 'mealplans_I'
        };

        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(part => part.length > 0);

        const destinationIndex = pathParts.findIndex(part => /_d\d+$/.test(part));

        if (destinationIndex !== -1 && destinationIndex < pathParts.length - 1) {
            const urlFilters = pathParts.slice(destinationIndex + 1);

            urlFilters.forEach(urlFilter => {
                const mappedDisplay = filterMappingDictionary[urlFilter];

                if (mappedDisplay && vm.popularFilters) {
                    const popularFilter = vm.popularFilters.find(filter =>
                        filter.display === mappedDisplay
                    );

                    if (popularFilter && !popularFilter.isSelected) {
                        popularFilter.isSelected = true;

                        if (!vm.filterCustomList.find(f => f.uri === popularFilter.uri)) {
                            vm.filterCustomList.push(popularFilter);
                        }
                    }
                } else if (vm.hotelFilters && vm.hotelFilters.filterCustoms && vm.hotelFilters.filterCustoms.filterGroups) {
                    vm.hotelFilters.filterCustoms.filterGroups.forEach(group => {
                        if (group.filters) {
                            const customFilter = group.filters.find(filter =>
                                filter.uri === urlFilter ||
                                filter.display === urlFilter ||
                                filter.uri.endsWith(`_${urlFilter}`) ||
                                filter.display.endsWith(`_${urlFilter}`)
                            );
                            if (customFilter && !vm.filterCustomList.find(f => f.uri === customFilter.uri)) {
                                customFilter.isSelected = true;
                                group.isSelected = false;
                                if (!customFilter.guid) {
                                    customFilter.guid = crypto.randomUUID();
                                }
                                vm.filterCustomList.push(customFilter);
                            }
                        }
                    });
                }
            });
        }

        isFirstPageLoad = false;
    }

    function updateSearch(search) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if (parseInt(params.page) > 1) {
            params.page = 1;
            search = '?' + Object.keys(params).map(key => key + '=' + params[key]).join('&');
        }
        return search;
    }

    function setIsSelect(filtersResponse) {
        const selected = []
        let newFilters = [];
        if (filtersResponse) {
            newFilters = filtersResponse.map((filters, ind) => {
                let selectedChild = filters.filters ? filters.filters.find(item => item.isSelected) : null;
                filters["isSelected"] = selectedChild ? false : true;
                if (filters.filters) {
                    const newFiltersChild = filters.filters.map(itemFilter => {
                        itemFilter["isMultiselect"] = filters.isMultiselect;
                        if (itemFilter.isSelected) {
                            selected.push(itemFilter);
                        }
                        return itemFilter;
                    });
                    filters["filters"] = newFiltersChild;
                }
                if (ind === 0) {
                    filters.filters = _listUtil.ptUsaProvisionalOrder(filters.filters);
                }

                return filters;
            })
        }

        vm.filtersSelectedArray = selected;
        vm.filtersSelectedArrayString = selected.map(item => item.uri);

        return newFilters;
    }


    /*
     Callbacks
     */
    function onSuccessPreviewHotels(data, filterResponse = false) {
        _globalUtil.windowScrollTop();
        let response = data.data;
        if (response) {
            vm.loading = false;
            vm.showAd = true;
            currentHotelList = response;
            vm.hotels = currentHotelList.accommodations || [];
            vm.hotels = vm.hotels.filter(ht => ht.mainPhoto && ht.mainPhoto.cloudUri && ht.mainPhoto.cloudUri.length);
            vm.groupedHotel = _listUtil.groupItems(vm.hotels, _size);


            vm.groupedHotel.forEach(groups => {
                groups.forEach(group => {
                    if (!group.price || group.price == 0) {
                        onSuccessDateRecommended(group);
                    }
                });
            });
            vm.pagination = _listUtil.buildPaginator(currentHotelList.totalItems, vm.hotels.length, vm.pagination.currentPage);
            vm.pagination.totalHotels = currentHotelList.totalItems;
            vm.pagination.pageSize = config.listItemsCount;

            loadFilters(currentHotelList.filterGroups);
            loopHotels(!filterResponse);

            if (config.showCardTags) {
                updateHotelTags(vm.groupedHotel);
            }

            if (!filterResponse) {
                onLoadRates();
                onLoadRatesPreLogin();
            }

            /*** Se ejecutara siempre que sea una respuesta por el servicio de filtros ***/
            if (filterResponse) {
                showAvailabilityReason();
            }

            if (vm.hotels.length && !settings.rb)
                setRecentDestination(vm.hotels);
        } else {
            onError(data);
        }
    }

    function onSuccessDateRecommended(hotel) {
        const language = config.culture.split('-')[0];
        if (!hotel.dateRecommended)
            return;

        hotel.dateRecommended.forEach(reservation => {
            const formattedCheckin = formatDate(reservation.checkin, language);
            const formattedCheckout = formatDate(reservation.checkout, language);
            const dateDifference = calculateDateDifference(reservation.checkin, reservation.checkout);

            reservation.checkinDayOfWeek = formattedCheckin.dayOfWeek;
            reservation.checkinDayAndMonth = formattedCheckin.dayAndMonth;
            reservation.checkoutDayOfWeek = formattedCheckout.dayOfWeek;
            reservation.checkoutDayAndMonth = formattedCheckout.dayAndMonth;
            reservation.dateDifference = dateDifference;
        });
    }

    function onSuccessLoadRatesWithLogin(response) {
        responseWithLogin.loaded = true;
        responseWithLogin.data = response.data.tax;
        mergeLoginRates();
    }

    function mergeLoginRates() {

        let factor = _isLogin ? -1 : 1;
        let taxInfo = responseWithLogin?.data ?? [];
        let hotelsLength = vm.groupedHotel.length;

        for (let i = 0; i < hotelsLength; i++) {
            let group = vm.groupedHotel[i];
            let groupLength = group.length;

            for (let j = 0; j < groupLength; j++) {
                let hotel = group[j];
                let prefix = hotel.productType == productType.hotel ? "h" : "a"
                let tax = taxInfo[`${prefix}${hotel.productId}`];
                if (tax && !config.hotelsTagLogin.listB.includes(hotel.productId)) {
                    let totalRoomRate = hotel.taxes ? hotel.taxes.totalRoomRate : 0;
                    let price_login = tax ? tax.totalRoomRate : totalRoomRate;
                    let saved = (totalRoomRate - price_login) * factor;
                    let discountPercentage = ((saved * 100) / totalRoomRate);
                    let isValid = discountPercentage > 2 && saved >= fn.thresHold(config.code);
                    hotel.price_with_login = price_login * factor;
                    hotel.total_saved = saved > 0 && isValid ? saved : 0;

                }

            }
        }
    }

    function onLoadRatesRequote(value, isRetry = false) {

        let hotelsId = _listUtil.getHotelOrAccomodationsIds(vm.hotels, productType.hotel);

        let paxesRates = box.pax;

        let dataRates = Object.keys(value.data.rates);
        hotelIdWithOutRates = hotelsId.filter((id) => !dataRates.includes(`h${id}`))

        let newPax = matchFamilyRule(paxesRates);

        vm.nightsList = box.pax.length || 0;

        if (!isRetry) {
            setInfoRooms(paramsRates, paxesRates);
        }

        /** Si no hay hoteles se respalda la respuesta de quote para recotizar posteriormente en filter*/
        if (!hotelIdWithOutRates.length) {
            retryData = value;
        }

        if (hotelIdWithOutRates.length && newPax && newPax.validRequote) {
            vm.paxData = newPax.paxes;
            dataRatesFetch = value;
            let cloneParamsRates = fn.clone(paramsRates);
            cloneParamsRates.hotelIds = hotelIdWithOutRates.join(",");
            cloneParamsRates.rooms = newPax.paxesFormat;

            setInfoRooms(cloneParamsRates, paxesRates);
            if (!_isLogin) {
                getOfertaWow();
            }

            $http.get(config.endPoints.quoteUrl, { params: cloneParamsRates, headers: getHeaders() }).then(onSuccessGetRatesRequote, onErrorLog);

        } else {
            if (!isRetry) {
                onSuccessGetRates(value);
            }
        }

    }

    function prepareMapData(hotels) {
        if (!hotels || hotels.length === 0) {
            return null;
        }

        const hotelsWithCoords = hotels.filter(hotel =>
            hotel.location &&
            hotel.location.latitude &&
            hotel.location.longitude &&
            !isNaN(parseFloat(hotel.location.latitude)) &&
            !isNaN(parseFloat(hotel.location.longitude))
        );

        if (hotelsWithCoords.length === 0) {
            return null;
        }

        const avgLat = hotelsWithCoords.reduce((sum, hotel) => sum + parseFloat(hotel.location.latitude), 0) / hotelsWithCoords.length;
        const avgLng = hotelsWithCoords.reduce((sum, hotel) => sum + parseFloat(hotel.location.longitude), 0) / hotelsWithCoords.length;

        const zoom = hotelsWithCoords.length === 1 ? 14 :
            hotelsWithCoords.length <= 3 ? 11 : 9;
        const markers = hotelsWithCoords.map((hotel, index) => ({
            lat: parseFloat(hotel.location.latitude),
            lng: parseFloat(hotel.location.longitude),
            title: hotel.name,
            label: (index + 1).toString(),
            hotelId: hotel.productId,
            city: hotel.location.city || '',
            address: hotel.location.street || ''
        }));

        return {
            center: { lat: avgLat, lng: avgLng },
            zoom: zoom,
            markers: markers,
            hotelsCount: hotelsWithCoords.length
        };
    }

    async function initializeInteractiveMap(mapData, containerId) {
        if (!mapData) return null;

        if (!window.google || !window.google.maps) {
            if (typeof config !== 'undefined' && config.endPoints && config.endPoints.googleMapsApi) {
                await new Promise((resolve) => {
                    fn.getScript(config.endPoints.googleMapsApi, "", resolve);
                });
            } else {
                return null;
            }
        }

        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const mapContainer = document.getElementById(containerId);
        if (!mapContainer) return null;
        mapContainer.innerHTML = '';

        const map = new Map(mapContainer, {
            center: mapData.center,
            zoom: mapData.zoom,
            mapId: 'hotel_list_map',
            renderingType: 'VECTOR',
            tilt: 60,
            heading: 0,
            gestureHandling: "greedy",
            disableDefaultUI: true
        });

        const bounds = new google.maps.LatLngBounds();
        const markerColor = settings.site.siteName == "pricetravel" ? '#5C469C' : '#DC3004';

        mapData.markers.forEach((markerData) => {
            const position = { lat: +markerData.lat, lng: +markerData.lng };
            bounds.extend(position);

            const container = document.createElement('div');
            container.style.cssText = `
                position: relative;
                background: white;
                padding: 8px 12px;
                border-radius: 6px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                font-size: 13px;
                font-weight: 500;
                color: #333;
                white-space: nowrap;
                display: flex;
                align-items: center;
                pointer-events: none;
            `;

            container.innerHTML = `
                <div style="display: flex; align-items: center;">
                    <svg width="14" height="14" viewBox="0 0 24 32" style="margin-right: 6px;" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 0C5.4 0 0 5.4 0 12c0 6.6 12 20 12 20s12-13.4 12-20C24 5.4 18.6 0 12 0z" fill="${markerColor}"/>
                        <circle cx="12" cy="12" r="6" fill="white"/>
                        <circle cx="12" cy="12" r="3" fill="${markerColor}"/>
                    </svg>
                    ${markerData.title}
                </div>
            `;

            new AdvancedMarkerElement({
                map: map,
                position: position,
                content: container,
                title: markerData.title
            });
        });

        if (mapData.markers.length > 1) {
            map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });
            google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                if (map.getZoom() > 15) {
                    map.setZoom(15);
                }
            });
        } else if (mapData.markers.length === 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        }

        return map;
    }

    function processLocationInfo(hotels) {
        if (!hotels || hotels.length === 0) {
            return { cities: [], countries: [], totalHotels: 0 };
        }

        const cities = new Set();
        const countries = new Set();

        hotels.forEach(hotel => {
            if (hotel.location) {
                if (hotel.location.city) {
                    cities.add(hotel.location.city);
                }
                if (hotel.location.country) {
                    countries.add(hotel.location.country);
                }
            }
        });

        return {
            cities: Array.from(cities),
            countries: Array.from(countries),
            totalHotels: hotels.length,
            mainCity: cities.size > 0 ? Array.from(cities)[0] : '',
            mainCountry: countries.size > 0 ? Array.from(countries)[0] : ''
        };
    }

    function processHotelServices(hotels) {
        if (!hotels || hotels.length === 0) {
            return [];
        }

        const serviceCount = {};
        const minHotelsRequired = Math.max(1, Math.floor(hotels.length * 0.2));

        hotels.forEach(hotel => {
            if (hotel.services && Array.isArray(hotel.services)) {
                hotel.services.forEach(service => {
                    if (service.name && service.name.trim()) {
                        const serviceName = service.name.trim();
                        serviceCount[serviceName] = (serviceCount[serviceName] || 0) + 1;
                    }
                });
            }
        });

        const topServices = Object.entries(serviceCount)
            .filter(([serviceName, count]) => count >= minHotelsRequired)
            .sort((a, b) => b[1] - a[1])
            .map(([serviceName]) => serviceName)
            .slice(0, 12);

        const midPoint = Math.ceil(topServices.length / 2);
        const firstColumn = topServices.slice(0, midPoint);
        const secondColumn = topServices.slice(midPoint);

        return {
            allServices: topServices,
            firstColumn: firstColumn,
            secondColumn: secondColumn
        };
    }

    function onSuccessOfertaWow(response) {
        vm.paramsRoomRates.loading = false;
        let data = response.data || {};
        if (response.status == 200) {
            vm.offerWow = data;
            vm.offerWow.selection = vm.offerWow.selection || {};
            vm.offerWow.selection.selectedRate = vm.offerWow.selection.selectedRate || {};
            let pax = fn.mapPaxToUrl(newPax.paxes);

            let query = "";
            let queryIsRequote = "";
            let paramsUri = {
                checkin: box.checkIn,
                checkout: box.checkOut,
                source: _paramQuery.source ? _paramQuery.source : "",
                promotions: _paramQuery.promotions
            };
            let checkIn = fn.getDate(box.checkIn);
            let checkOut = fn.getDate(box.checkOut);

            if (_campaignToken) {
                paramsUri.CampaignToken = _campaignToken;
            }
            if (_paramQuery.coupon) {
                paramsUri.coupon = _paramQuery.coupon;
            }

            let paramsUriConcat = { ...paramsUri, ...pax };

            query = fn.objectToQueryParams(paramsUriConcat);

            vm.offerWow.hotels.forEach(hotel => {
                const copyHotel = { ...hotel, productId: hotel.hotelId, productType: 1 };
                hotel.url = _listUtil.getUrlToDetail(copyHotel, query);
            });

            // Procesar servicios de los hoteles para mostrar en el modal
            const servicesData = processHotelServices(vm.offerWow.hotels);
            vm.offerWow.topServices = servicesData.allServices;
            vm.offerWow.firstColumnServices = servicesData.firstColumn;
            vm.offerWow.secondColumnServices = servicesData.secondColumn;

            vm.offerWow.mapData = prepareMapData(vm.offerWow.hotels);
            vm.offerWow.isMapExpanded = false;

            vm.offerWow.locationInfo = processLocationInfo(vm.offerWow.hotels);

            vm.offerWow.initializeMap = function () {
                if (vm.offerWow.mapData) {
                    setTimeout(async () => {
                        vm.offerWow.map = await initializeInteractiveMap(vm.offerWow.mapData, 'oferta-wow-map');
                    }, 100);
                }
            };

            vm.offerWow.zoomIn = () => {
                if (vm.offerWow.map) {
                    vm.offerWow.map.setZoom(vm.offerWow.map.getZoom() + 1);
                }
            };

            vm.offerWow.zoomOut = () => {
                if (vm.offerWow.map) {
                    vm.offerWow.map.setZoom(vm.offerWow.map.getZoom() - 1);
                }
            };

            vm.offerWow.toggleExpand = () => {
                const mapDiv = document.getElementById('oferta-wow-map');
                if (!mapDiv) return;

                const element = mapDiv.parentElement; // Expandimos el contenedor para no perder los controles
                if (!element) return;

                if (!document.fullscreenElement) {
                    if (element.requestFullscreen) element.requestFullscreen();
                    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
                    else if (element.msRequestFullscreen) element.msRequestFullscreen();
                } else {
                    if (document.exitFullscreen) document.exitFullscreen();
                    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
                    else if (document.msExitFullscreen) document.msExitFullscreen();
                }
            };

            document.addEventListener('fullscreenchange', () => {
                vm.offerWow.isMapExpanded = !!document.fullscreenElement;
                if (!$scope.$$phase) $scope.$apply();
            });

            document.addEventListener('webkitfullscreenchange', () => {
                vm.offerWow.isMapExpanded = !!document.webkitFullscreenElement;
                if (!$scope.$$phase) $scope.$apply();
            });
        }
    }
    function onSuccessFilterResponse(response) {
        let data = response.data || {};
        const hasValidFilters = response.status === 200
            && data.filterCustoms
            && Array.isArray(data.filterCustoms.filterGroups)
            && data.filterCustoms.prices
            && Array.isArray(data.accommodations);

        if (!hasValidFilters) {
            onErrorHotelsFilters(response);
            return;
        }

        if (response.status == 200) {

            filtersLoaded = true;
            vm.loading = false;
            vm.loadingRates = false;
            vm.hotelFilters = data;
            vm.hotelFilters.error = false;
            vm.hotelFilters.loading = false;
            vm.paramsFilter.searchDatesRecommended = false;
            vm.hotelFilters.filterCustoms.filterGroups = _listUtil.setIsSelectCustomFilter(data.filterCustoms.filterGroups);
            vm.composition = vm.hotelFilters.filterCustoms.composition;
            vm.popularFilters = vm.hotelFilters.filterCustoms.filterPopular || [];
            vm.hotelFilters.filterCustoms.prices.min = (vm.hotelFilters.filterCustoms.prices.min) * exchange.rate;
            vm.hotelFilters.filterCustoms.prices.max = (vm.hotelFilters.filterCustoms.prices.max) * exchange.rate;
            updateFilterCustom();

            initializeSliders(vm.hotelFilters.filterCustoms.prices, data.accommodations);
            onSuccessPreviewHotels(response, true);
            //MAPPEAR LOS FILTROS CUSTOMS POR LOS SELECCIONADOS
            vm.hotelFilters.filterCustoms.filterGroups.forEach(group => {
                group.filters.forEach(filter => {
                    const inCustomList = vm.filterCustomList.find(f => f.uri === filter.uri);
                    const inUrlFilters = vm.filtersSelectedArrayString.includes(filter.uri);

                    if (inCustomList || inUrlFilters) {
                        filter.isSelected = true;
                        if (!filter.guid) {
                            filter.guid = (inCustomList && inCustomList.guid) ? inCustomList.guid : crypto.randomUUID();
                        }
                        const existingIndex = vm.filterCustomList.findIndex(f => f.uri === filter.uri);
                        if (existingIndex > -1) {
                            vm.filterCustomList.splice(existingIndex, 1);
                        }
                        vm.filterCustomList.push(filter);
                    }
                });
            });
            //ASIGNAR TEXTO ORDENAMIENTO POR URL
            vm.hotelFilters.filterCustoms.orderBy.forEach(group => {
                if (vm.paramsFilter.orderBy == group.code) {
                    vm.textOrderBy = group.display;
                }
            });

            const allConfiguredPromos = getAllFilterPromotions();
            if (allConfiguredPromos.length > 0) {
                const configuredPromotions = allConfiguredPromos.map(promo => promo.filterName);

                const promotionGroup = vm.hotelFilters.filterCustoms.filterGroups.find(x => x.id === 103);
                const promotionFilters = promotionGroup ? promotionGroup.filters.filter(filter =>
                    configuredPromotions.includes(filter.display)
                ) : [];
                const otherFilters = vm.popularFilters.filter(filter =>
                    !configuredPromotions.includes(filter.display)
                );
                vm.popularFilters = [...promotionFilters, ...otherFilters];
            }

            vm.filterHotelsOrHouses = vm.hotelFilters.filterCustoms.filterGroups.filter(f => f.uri === "propertytype");
            // vm.pillPropertTypeFilter = vm.hotelFilters.filterCustoms.filterGroups.filter(f => f.uri === "propertyselection");

            applyUrlFilters();

            /** Disparar view_item_list cuando los hoteles vienen del flujo de filtros (cambio de orden, filtros, paginación) */
            if (filtersInitReq && vm.hotels.length) {
                tracker.viewItemList(vm.hotels);
            }

            /** Solo ejecutar cuando se aplican o eliminan filtros */
            if (filtersInitReq) {
                onLoadRatesPreLogin();
            }

            if (allowRequest) {
                initializeFilters();
            }

            filtersInitReq = true;

            /** si la recotización intento ejecutarse antes de la respuesta de filtros */
            if (retryData) {
                onLoadRatesRequote(retryData, true);
            }
            mergeLoginRates();
        }
    }

    function onSuccessGetRates(data) {

        let response = data.data;
        if (response) {
            rates = response || {};
            const rateTaxes = Object.values(response.tax || {});
            if (rateTaxes.length) {
                updatePriceHistograms(rateTaxes);
            }

            if (!filtersLoaded) {
                matchHotelWithRate();
            }

            vm.loadingRates = false;
            tracker.afterLoadRates();
            tracker.viewItemList(vm.hotels);
            if (response.campaignToken && response.campaignToken.length) {
                $location.search('ctInternal', response.campaignToken)
            }
            _campaignToken = response.campaignToken;
            showAvailabilityReason();

        } else {
            onError(data);
        }

        $('.seo-list-init').remove();



    }

    function onSuccessGetRatesRequote(valueRequote) {
        let resultRequote = familyRequote(dataRatesFetch, valueRequote);
        onSuccessGetRates(resultRequote);
        loopHotels();
        mergeLoginRates();
    }

    function onSuccessAvailabilityReasons({ data }) {
        if (data && data.status === "ok") {
            let firstHotel = vm.hotels[0] || {};
            getRecommendedDates(firstHotel.productId, data.message);
        }
    }

    function onRenderRecomendedDates(res) {
        if (res && res.data && res.data.message) {
            const hotel = vm.hotels[0];
            let recommendedDates = Object.values(res.data.message);

            hotel.checkIn = params.checkIn;
            hotel.checkOut = params.checkOut;

            hotel.recommendedDates = recommendedDates.map(item => {
                return {
                    ...item,
                    people: _paxes.adults + _paxes.children,
                    rooms: box.pax.rooms,
                    hotelId: hotel.productId,
                    hotelName: hotel.name
                }
            });

        }
    }

    function onSuccessSkillBase(data) {
        let response = data.data;
        if (response.message == _successSkillBase) {
            skillBase = response.result;
            vm.phoneBase = skillBase.did;
            $('.skillbase_p')
                .closest('a')
                .attr('href', `tel:${vm.phoneBase}`);
            $('.skillbase_p').text($filter('tel')(vm.phoneBase));
        } else {
            onErrorLog(data);
        }
    }

    function onSuccessPaymentMethods(response) {
        const data = response.data || [];
        const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
        const groupedPayments = monthInterestFree.reduce((groups, item) => {
            const maxMonths = Math.max(...item.paymentPlans);
            if (!groups[maxMonths]) {
                groups[maxMonths] = [];
            }
            groups[maxMonths].push(item);
            return groups;
        }, {});
        const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));

        const depositBanks = getDepositBanks(data);

        const depositAccountName = getDepositAccountName(data);

        const depositContactEmail = getDepositContactEmail(data);

        const paymentMethods = {
            fixedPayments: data.fixedPayments
                .map(fixedPayments => fixedPayments.options)
                .reduce((prev, curr) => prev.concat(curr), []),
            monthInterestFree: sortedEntries,
            quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
            otherPayments: data.otherPayments ? data.otherPayments.options : [],
            depositBanks: depositBanks,
            depositAccountName: depositAccountName,
            depositContactEmail: depositContactEmail,
            loading: false,
            title: data.quotasPayments ? data.quotasPayments.title : "",
            maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
        };
        vm.responsePayment = paymentMethods;
        vm.monthInterestData = data.monthInterestFree || [];
    }

    function onChangeRangePrice(values) {
        $scope.$apply(function () {
            var min = values[0] || 0;
            var max = values[1] || 0;
            vm.filterSelection.min = min;
            vm.filterSelection.max = max;
            updateNativePriceRanges(min, max);
            setBoxRangeValue(min, max);
        });
    }

    function onKeyupSliderBox(e, prop) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            $(e.target).trigger('blur');
            return;
        }

        const limits = vm.hotelFilters && vm.hotelFilters.filterCustoms && vm.hotelFilters.filterCustoms.prices ? vm.hotelFilters.filterCustoms.prices : { min: 0, max: 9999999 };
        const strnum = String(e.target.value).replace(/[.,\s]/g, '');
        let value = Math.abs(parseInt(strnum, 10));

        if (isNaN(value)) {
            value = limits[prop] || 0;
        }

        value = Math.max(limits.min, Math.min(limits.max, value));
        if (prop === 'min') {
            value = Math.min(value, vm.filterSelection.max);
        } else {
            value = Math.max(value, vm.filterSelection.min);
        }

        vm.filterSelection[prop] = value;
        updateNativePriceRanges(vm.filterSelection.min, vm.filterSelection.max);
    }

    function onChangeSliderBox(e, prop) {
        if (e && prop && e.target) {
            const limits = vm.hotelFilters && vm.hotelFilters.filterCustoms && vm.hotelFilters.filterCustoms.prices ? vm.hotelFilters.filterCustoms.prices : { min: 0, max: 9999999 };
            const strnum = String(e.target.value).replace(/[.,\s]/g, '');
            let value = Math.abs(parseInt(strnum, 10));

            if (isNaN(value)) {
                value = limits[prop] || 0;
            }

            value = Math.max(limits.min, Math.min(limits.max, value));
            if (prop === 'min') {
                value = Math.min(value, vm.filterSelection.max);
            } else {
                value = Math.max(value, vm.filterSelection.min);
            }

            vm.filterSelection[prop] = value;
        }

        setBoxRangeValue(vm.filterSelection.min, vm.filterSelection.max);
        onChangeWithReloadRangePrice([vm.filterSelection.min, vm.filterSelection.max]);
    }

    function setBoxRangeValue(min, max) {
        const thousandSeparator = window.__pt.settings.site.cultureSite == "es-co" ? "." : ",";
        const formattedMin = (Math.round(min) + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
        const formattedMax = (Math.round(max) + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

        $('.min_slider_box').each(function () {
            if (!$(this).is(':focus')) {
                $(this).val(formattedMin);
            }
        });

        $('.max_slider_box').each(function () {
            if (!$(this).is(':focus')) {
                $(this).val(formattedMax);
            }
        });
    }

    function onChangeWithReloadRangePrice(value) {
        onChangeRangePrice(value);
        vm.onSubmitFilter();
    }

    /**
     * Callbacks Errors
     */
    function setFilterPhillRange() {

        vm.paramsFilter.filterPriceMin = vm.filterSelection.min;
        vm.paramsFilter.filterPriceMax = vm.filterSelection.max;

        if (Math.round(vm.hotelFilters.filterCustoms.prices.min) === vm.filterSelection.min) {
            vm.paramsFilter.filterPriceMin = vm.hotelFilters.filterCustoms.prices.min;
        } else if (Math.round(vm.hotelFilters.filterCustoms.prices.max) === vm.filterSelection.max) {
            vm.paramsFilter.filterPriceMax = vm.hotelFilters.filterCustoms.prices.max;
        }

        if (
            Math.round(vm.filterSelection.min) > Math.round(vm.hotelFilters.filterCustoms.prices.min)
            || Math.round(vm.filterSelection.max) < Math.round(vm.hotelFilters.filterCustoms.prices.max)
        ) {
            const minFormatted = $filter('currency')(vm.filterSelection.min, 0, false);
            const maxFormatted = $filter('currency')(vm.filterSelection.max, 0, false);
            vm.pricesSelected = [
                {
                    display: `De: $${minFormatted + ""} a 
                    $${maxFormatted}`
                }
            ];
        } else {
            vm.pricesSelected = [];
        }
    }

    function onError(data) {
        let response = data.data;
        vm.loadingRates = false;
        vm.loading = false;
        vm.hasError = true;
        vm.hotels = [];
        vm.groupedHotel = [];
        vm.filters = [];
        tracker.errorQuote(response, 'Content Facade');
    }

    function onErrorRates(data) {
        let response = data.data;
        vm.loadingRates = false;
        vm.loading = false;
        vm.loadingRefresh = false;
        tracker.errorQuote(response, 'Rates');
        console.log("error", response);
    }

    function onErrorLog(data) {
        console.log(data)
    }

    function onErrorHotelsFilters(data) {
        vm.loading = false;
        if (vm.hotelFilters) {
            vm.hotelFilters.loading = false;
            vm.hotelFilters.error = true;
        }
        console.log(data);
    }

    /**
     * Misc
     */


    function showAds() {
        fn.onViewComponent("#ad-skyscraper-1", onShowAds, { ad: 1 });
        fn.onViewComponent("#ad-skyscraper-2", onShowAds, { ad: 2 });
        fn.onViewComponent("#ad-skyscraper-3", onShowAds, { ad: 3 });
    }

    function onShowAds(param) {
        tracker.ad(param.ad, _paxes, paramsRates)
    }

    function setRecentDestination(list) {

        SearchHistory.createOrUpdateDestination(list, place, box);
    }

    function setInfoRooms(paramsRoomRates, paxes) {
        let checkIn = fn.getDate(paramsRoomRates.checkIn);
        let checkOut = fn.getDate(paramsRoomRates.checkOut);
        let nights = fn.diffBetweenDays(checkIn, checkOut);
        let rooms = paxes.rooms;
        let totalPax = paxes.adults + paxes.children;
        vm.boxData = { rooms, nights, totalPax, adults: paxes.adults, children: paxes.children, checkIn, checkOut };
    }
    vm.updateFilterCustom = updateFilterCustom;
    function updateFilterCustom() {
        var filtersCustom = vm.hotelFilters.filterCustoms || {};

        if (!vm.paramsFilter.orderBy && filtersCustom.orderBy && filtersCustom.orderBy.length) {
            vm.paramsFilter.orderBy = filtersCustom.orderBy[0].code;
            vm.textOrderBy = filtersCustom.orderBy[0].display;
        }

        $('.collapse_filter').collapse('show');
        vm.toggleRange = true;
    }

    function changeTextTitle() {
        vm.title = `${_pref} ${place.displayText}`;
    }

    function showAvailabilityReason() {
        let firstHotel = vm.hotels[0] || {};

        if (firstHotel && !firstHotel.price && config.recommenderDatesActive) {
            getAvailabilityReasons(firstHotel.productId);
        }
    }

    // Método para procesar reserva desde modal de oferta especial
    vm.onSubmit = (room, rate, hotel, paynow = false) => {
        var paxesToSend = [];
        paxesToSend = newPax.paxesFormat;
        const paxesData = fn.mapPaxToUrlNew(paxesToSend, true, true);
        let items = [];
        items.push({
            idRate: rate.rateId,
            rateKey: rate.rateKey,
            idRoom: rate.roomId,
            promotionValue: rate.promotionValue,
            totalRoomRatePerNight: rate.taxes.totalRoomRatePerNight,
            mealPlanCode: rate.mealPlanCode,
            totalAmount: rate.totalAmount,
            checkoutHash: rate.checkoutHash,
            isBookNowPayLater: paynow,
            rooms: newPax.paxes.rooms,
            pax: rate.paxFam,
            index: 1,
            provider: rate.provider
        });

        let data = {
            idHotel: hotel.hotelId,
            hotelCheckIn: box.checkIn,
            CheckIn: box.checkIn,
            CheckOut: box.checkOut,
            Source: config.source,
            ChkSource: isMobile ? config.chkSourceMobile : config.chkSourceDesktop,
            ChkSourceGroup: isMobile ? config.chkSourceGroupMobile : config.chkSourceGroupDesktop,
            isBookNowPayLater: paynow,
            index: 1,
            pageUrl: window.location.pathname + window.location.search,
            isMetaSearchEngine: vm.source_origin !== "",
            Amount: rate.totalAmount,
            useNewConfig: true,
            applicable: true,
            offerWow: true
        };
        data = { ...data, ...paxesData, site: settings.site.siteName };

        var form = document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("action", `/${cultureData.cultureCode}${config.checkoutUrl}`);
        StorageService.setSession(data);
        for (var key in data) {
            if (data[key] != null) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", data[key]);
                form.appendChild(hiddenField);
            }
        }
        items.map((room, index) => {
            for (var key in room) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", `roomList[${index}][${key}]`);
                hiddenField.setAttribute("value", room[key]);
                form.appendChild(hiddenField);
            }
        });
        const eventData = {
            ...data
        }
        tracker.clickOfferWow(_paxes);

        document.body.appendChild(form);
        form.submit();
    };

    vm.slideCarousel = async (evt, hotel, direction) => {
        evt.preventDefault();
        evt.stopPropagation();

        const carousel = evt.currentTarget.closest('.carousel');
        if (!carousel || !carousel.__carouselApi) return;

        let isFirstLoad = false;
        if (!hotel.gallery || !hotel.gallery.length) {
            await vm.loadHotelSlide(hotel, 0);
            isFirstLoad = true;
        }

        if (isFirstLoad) {
            $timeout(function() {
                const maxSlides = hotel.gallery.length;
                if (direction === 'next') carousel.__carouselApi.next(maxSlides);
                else carousel.__carouselApi.prev(maxSlides);
            }, 10);
        } else {
            const maxSlides = hotel.gallery.length;
            if (direction === 'next') carousel.__carouselApi.next(maxSlides);
            else carousel.__carouselApi.prev(maxSlides);
        }
    };

    vm.loadHotelSlide = async function (hotel, slideIndex) {
        if (!hotel.isLoadGallery) {
            let qr = {
                culture: params.culture,
                organizationId: params.organizationId,
                ...(hotel.id && { HotelId: hotel.id }),
                propertyId: hotel.id ? params.propertyId : hotel.productId,
                imageProfileId: 'desktop',
                productType: hotel.productType
            };

            let response = await $http.get(config.endPoints.galleryDetailUrl, { params: qr });

            let firstPhoto = hotel.mainPhoto || { cloudUri: hotel.cloudUri };
            hotel.gallery = fn.clone([firstPhoto, ...response.data.gallery]);
            hotel.isLoadGallery = true;
        }

        if (!hotel.gallery || !hotel.gallery.length)
            return;

        const index = Math.abs(slideIndex % hotel.gallery.length);

        $timeout(function () {
            hotel.mainPhoto = hotel.gallery[index];
        }, 0);
    };

    // ==========================================
    // NUEVA LÓGICA DE CAMPAÑAS CENTRALIZADAS CDN
    // ==========================================

    function getAllFilterPromotions() {
        let list = [];
        if (window.__pt && Array.isArray(window.__pt.campaings)) {
            window.__pt.campaings.forEach(c => {
                if (c) {
                    const badgeType = c.badgeType || '';
                    const badgeText = c.badgeText || '';
                    if (c.filterName && typeof c.filterName === 'string') {
                        list.push({
                            filterName: c.filterName.trim(),
                            badgeType,
                            badgeText
                        });
                    }
                }
            });
        }
        return list;
    }

    vm.getFilterPromotion = (filter) => {
        const allPromos = getAllFilterPromotions();
        if (allPromos.length > 0) {
            return allPromos.some(promo => promo.filterName === filter.display);
        }
        return false;
    };

    vm.getFilterPromotionType = (filter) => {
        const allPromos = getAllFilterPromotions();
        if (allPromos.length > 0) {
            const filterPromo = allPromos.find(promo => promo.filterName === filter.display);
            if (filterPromo) {
                return filterPromo.badgeType;
            }
        }
        return null;
    };

    vm.getFilterPromotionConfig = (filter) => {
        const allPromos = getAllFilterPromotions();
        if (allPromos.length > 0) {
            return allPromos.find(promo => promo.filterName === filter.display);
        }
        return null;
    };

    vm.getHotelBadgeClass = (hotel) => {
        if (!hotel) return '';
        if (hotel.campaignObj && hotel.campaignObj.badgeType) {
            return 'bg-' + hotel.campaignObj.badgeType.trim().toLowerCase();
        }
        if (window.__pt && Array.isArray(window.__pt.campaings)) {
            for (const campaign of window.__pt.campaings) {
                if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(hotel.productId || hotel.id))) {
                    return 'bg-' + campaign.badgeType.trim().toLowerCase();
                }
            }
        }
        return '';
    };

    vm.getCampaignBadge = (hotel) => {
        if (!hotel || !hotel.campaignObj || !hotel.campaignObj.badgeType) return null;
        const badgeNormalized = hotel.campaignObj.badgeType.trim().toLowerCase();
        let icon = '';
        if (badgeNormalized === 'hotsale' || badgeNormalized === 'ofertahot') {
            icon = 'icon icons-flame1 font-oncolor';
        } else if (badgeNormalized === 'blackdays') {
            icon = 'icon icons-moon';
        } else if (badgeNormalized === 'blackfriday') {
            icon = 'icon icons-tag';
        }

        let text = hotel.campaignObj.badgeType;
        if (hotel.campaignObj.badgeText && typeof hotel.campaignObj.badgeText === 'string' && hotel.campaignObj.badgeText.trim() !== '') {
            text = hotel.campaignObj.badgeText.trim();
        } else if (window.__pt && window.__pt.ln) {
            if (window.__pt.ln.campaigns && window.__pt.ln.campaigns[badgeNormalized]) {
                text = window.__pt.ln.campaigns[badgeNormalized];
            }
        }
        return {
            badgeType: badgeNormalized,
            icon: icon,
            text: text,
            badgeIcon: hotel.campaignObj.badgeIcon || '',
            hasIcon: hotel.campaignObj.hasIcon || false,
            hasBankPromotion: hotel.campaignObj.hasBankPromotion || false
        };
    };

}
